import moment from 'moment';
import Swal from 'sweetalert2';

import { NotificationToast } from '../classess/main/notifications/notificationToast';
import { Toast } from '../classess/notifications/toast';

const $ = window.jqGlobal || window.jQuery;

// require('dotenv').config(); // Eliminado: CRA maneja esto nativamente para variables REACT_APP_

const {
    REACT_APP_LOCALSTORAGE_ID,
    REACT_APP_TITLE, REACT_APP_VERSION, REACT_APP_YEAR, REACT_APP_COPYRIGHT, REACT_APP_REACT_ENV,
    REACT_APP_RECAPTCHAv2_SITE_KEY, REACT_APP_RECAPTCHAv3_SITE_KEY,
    REACT_APP_ADMIN_EMAIL,
} = process.env;

//#region old code
// export function getResponse({
//     type = 0,
//     msgText = '',
//     urlGoTo = '',
// } = {}
// ) {
//     const responseHeader = {
//         isSuccess: type === -1 ? false : true,
//         isWarning: type === 1 ? true : false,
//         msgType: type,
//     };

//     return {
//         ...responseHeader,
//         msgText: msgText,
//         msgTextHtml: '',
//         result: null,
//         urlGoTo: urlGoTo,
//         record: {
//             delete: false,
//             notFound: false,
//         }
//     }
// }
//#endregion old code

export function getResponse({
    type = 0,
    msgText = '',
    urlGoTo = '',
    currentMethod_ = '',
    subMethod_ = ''
} = {}) {
    const currentMethod = 'getResponse';

    const responseHeader = {
        isSuccess: type === -1 ? false : true,
        isWarning: type === 1 ? true : false,
        msgType: type,
    };

    let msgText__ = '';
    if (currentMethod_ !== undefined && currentMethod_ !== null && currentMethod_ !== '') {
        msgText__ += `Method: ${currentMethod}<br/>`;
    }
    if (subMethod_ !== undefined && subMethod_ !== null && subMethod_ !== '') {
        msgText__ += `Sub method: ${subMethod_}<br/>`;
    }
    if (msgText !== undefined && msgText !== null && msgText !== '') {
        msgText__ += `${msgText}<br/>`;
    }

    const responseBody = {
        msgText: msgText__,
        msgTextHtml: '',
        result: null,
        urlGoTo: urlGoTo,
        record: {
            delete: false,
            notFound: false,
        }
    };

    return { ...responseHeader, ...responseBody };
}

// Inicializador global para Dropdowns inyectados dinámicamente por DataTables
if (typeof document !== 'undefined' && $) {
    $(document).on('draw.dt', function () {
        if ($.fn && $.fn.dropdown) {
            $('[data-toggle="dropdown"]').dropdown();
        }
    });
}

export function getGlobalFormat() {
    return {
        code: '',
        id: '',
        format: {
            date: {
                f1: '',
                f2: '',
                f3: '',
                f4: '',
                f5: '',
                f6: '',
                f7: '',
                f8: '',
                f9: '',
                f10: '',
                f11: '',
                f12: '',
                f13: '',
            },
            time: {
                f1: '',
                f2: '',
                f3: '',
                f4: '',
                picker: {
                    hhmm: '',
                    hhmmss: '',
                },
                type: 0,
            },
        },
        numbers: {
            separators: {
                decimals: '',
                thousands: '',
            },
        },
    };
}

export const getRolesType = () => {
    return {
        isAdmin: false,
        isAnalyst: false,
        isAnonymous: true,
        isService: false,
        isUser: false,
        isUserAdmin: false,
    }
};

const settingsPassword = Object.freeze({
    minLength: 6,
})

export const settings = Object.freeze({
    app: {
        copyRight: REACT_APP_COPYRIGHT,
        title: REACT_APP_TITLE,
        version: REACT_APP_VERSION,
        views: {
            accounts: {
                accounts: 'accounts',
                passwordRecover: 'passwordRecover',
                requestAccount: 'requestAccount',
                requestAccountMonitor: 'requestAccountMonitor',
            },
            analysts: {
                analysts: 'analysts',
            },
            backupReviews: {
                backupReviews: 'backupReviews',
            },
            configurations: {
                configurations: 'configurations',
            },
            countries: {
                countries: 'countries',
            },
            companies: {
                companies: 'companies',
            },
            customers: {
                customers: 'customers',
            },
            dataCenter: {
                dataCenter: 'dataCenter',
            },
            devices: {
                devices: 'devices',
            },
            domainHosting: {
                domainHosting: 'domainHosting',
            },
            main: {
                about: 'about',
                contact: 'contact',
                home: 'home',
                index: 'index',
                login: 'login',
                privacy: 'privacy',
            },
            notifications: {
                toast: {
                    toast: 'toast',
                },
            },
            parameters: {
                parameters: 'parameters',
            },
            paymentInformations: {
                paymentInformations: 'paymentInformations',
            },
            profile: {
                profile: 'profile',
            },
            purchases: {
                billToPay: 'billToPay',
            },
            requirements: {
                requirements: 'requirements',
            },
            remoteConnections: {
                remoteConnections: 'remoteConnections',
            },
            settings: {
                settings: 'settings',
            },
            services: {
                services: 'services',
            },
            systemAccesses: {
                systemAccesses: 'systemAccesses',
            },
            sites: {
                sites: 'sites',
            },
            status: {
                status: 'status',
            },
            types: {
                types: 'types',
            },
            users: {
                user: 'user',
                users: 'users',
            },
        },
        year: REACT_APP_YEAR,
    },
    backend: {
        methods: {
            backupReviews: {
                getAll: 'getAll',
                getById: 'getById',
                getByCustomerSecundaryId: 'getByCustomerSecundaryId',
            },
            backupReviewDetails: {
                getAll: 'getAll',
                getById: 'getById',
            },
            dataCenters: {
                getAll: 'getAll',
                getById: 'getById',
            },
            domainHostings: {
                getAll: 'getAll',
                getById: 'getById',
            },
            countries: {
                getAll: 'getAll',
                getById: 'getById',
            },
            companies: {
                getAll: 'getAll',
                getById: 'getById',
            },
            configurations: {
                getAll: 'getAll',
                getById: 'getById',
            },
            customers: {
                getAll: 'getAll',
                getById: 'getById',
                externalInfo: 'externalInfo',
            },
            devices: {
                getAll: 'getAll',
                getById: 'getById',
            },
            home: {
                homeDataGet: 'homeDataGet',
            },
            main: {
                reports: {
                    pdf: 'pdfReport',
                },
            },
            notifications: {
                toasts: {
                    create: 'create',
                    getAll: 'getAll',
                    getById: 'getById',
                    getCMNtNr: 'getCMNtNr',
                },
            },
            parameters: {
                getAll: 'getAll',
                getById: 'getById',
            },
            parameterDetails: {
                getAll: 'getAll',
                getById: 'getById',
            },
            paymentInformations: {
                getAll: 'getAll',
                getById: 'getById',
                getAllWithDetails: 'getAllWithDetails',
            },
            paymentInformationDetails: {
                getAll: 'getAll',
                getById: 'getById',
            },
            requestAccounts: {
                getById: 'getById',
                getByUserNameAndEmail: 'getByUserNameAndEmail',
            },
            requirements: {
                getAdd: 'getAdd',
                getAll: 'getAll',
                getById: 'getById',
            },
            requirementDetails: {
                getAll: 'getAll',
                getById: 'getById',
            },
            remoteConnections: {
                getAll: 'getAll',
                getById: 'getById',
            },
            roles: {
                getAll: 'getAll',
                getById: 'getById',
                getAllUsers: 'getAllUsers',
                getAnalysts: 'getAnalysts',
            },
            sales: {
                getBillToPay: 'getBillToPay',
                getDetailDocuments: 'getDetailDocuments',
                getBillToPayCompanyCustomers: 'getBillToPayCompanyCustomers',
                getBillToPayCompanyCustomer: 'getBillToPayCompanyCustomer',
            },
            status: {
                getAll: 'getAll',
                getById: 'getById',
            },
            systemAccesses: {
                getAdd: 'getAdd',
                getAll: 'getAll',
                getById: 'getById',
            },
            systemAccessDetails: {
                getAdd: 'getAdd',
                getAll: 'getAll',
                getById: 'getById',
            },
            types: {
                getAll: 'getAll',
                getById: 'getById',
            },
            users: {
                getAll: 'getAll',
                getById: 'getById',
                getAnalysts: 'getAnalysts',
                getAllNotAnalysts: 'getAllNotAnalysts',
                getByIdWithCompaniesAccess: 'getByIdWithCompaniesAccess',
                getAnalystByIdWithCompaniesAccess: 'getAnalystByIdWithCompaniesAccess',
                passwordChange: 'passwordChange',
                passwordRecoverGet: 'passwordRecoverGet',
                passwordRecoverCheck: 'passwordRecoverCheck',
                passwordRecoverChangePassword: 'passwordRecoverChangePassword',
            },
            userCompanyCustomers: {
                getAllWithDetailsByUserCompanyId: 'getAllWithDetailsByUserCompanyId'
            },
        },
        urls: {
            // api: 'https://chejconsultorcabackend.up.railway.app',
            // api: 'http://localhost:3001',
            api: REACT_APP_REACT_ENV === 'dev' ? 'http://localhost:3001' : 'https://chejconsultorcabackend.up.railway.app',
            about: '/about',
            accounts: '/accounts',
            analysts: '/analysts',
            apiV1: '/api/v1',
            backupReviews: '/backupReviews',
            backupReviewDetails: '/backupReviewDetails',
            changePassword: '/changePassword',
            configurations: '/configurations',
            contact: '/contact',
            contactMessages: '/contactMessages',
            countries: '/countries',
            companies: '/companies',
            customers: '/customers',
            dataCenters: '/dataCenters',
            dev: 'http://localhost:3001',
            devices: '/devices',
            domainHostings: '/domainHostings',
            forgotPassword: '/forgotPassword',
            home: '/home',
            images: '/images',
            imageIcons: '/images/icons',
            imageLogos: '/images/logos',
            notifications: '/notifications',
            notFound: '/notFound',
            login: '/login',
            parameters: '/parameters',
            parameterDetails: '/parameterDetails',
            paymentInformations: '/paymentInformations',
            paymentInformationDetails: '/paymentInformationDetails',
            privacy: '/privacy',
            profile: '/profile',
            recoverPassword: '/recoverPassword',
            register: '/register',
            requestAccount: '/requestAccount',
            requestAccountDetails: '/requestAccountDetails',
            requestAccountMonitor: '/requestAccountMonitor',
            requirements: '/requirements',
            requirementDetails: '/requirementDetails',
            remoteConnections: '/remoteConnections',
            roles: '/roles',
            sales: '/sales',
            saleDetailDocuments: '/saleDetailDocuments',
            saleDetailStatementAccounts: '/saleDetailStatementAccounts',
            saleUserCompanyCustomers: '/saleUserCompanyCustomers',
            status: '/status',
            systemAccesses: '/systemAccesses',
            systemAccessDetails: '/systemAccessDetails',
            toasts: '/toasts',
            types: '/types',
            users: '/users',
            userCompanies: '/userCompanies',
            userCompanyCustomers: '/userCompanyCustomers',
        },
    },
    colors: {
        dangerColorExp: '#DC3545',
        infoColorExp: '#18A2B8',
        primaryColorExp: '#007BFF',
        secondaryColorExp: '#747474',
        successColorExp: '#53a451',
        warningColorExp: '#f7c244',
    },
    files: {
        paymentInformation: {
            logo: {
                quantity: 1,
                maxSize: 2097152,
            },
        },
        profile: {
            logo: {
                quantity: 1,
                maxSize: 2097152,
            },
        },
        acceptedTypes: {
            images: ['image/png', 'image/jpeg', 'image/jpg', 'image/bmp',],
            filesOne: ['application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',],
            filesTwo: ['application/pdf', 'text/plain',],
            filesThree: ['application/vnd.ms-powerpoint', 'application/vnd.openxmlformats-officedocument.presentationml.presentation',],
            filesOnlyPdf: ['application/pdf'],
        },
    },
    gifs: {
        normal: {
            loading: '/images/loading/loading.gif',
            circle: '/images/loading/circle.gif',
            circle2: '/images/loading/circle2.gif',
        },
        svg: {
            spinner: '/images/loading/spinner.svg',
            spinnerWhite: '/images/loading/spinner-white.svg',
            typing: '/images/loading/typing.svg',
        },
    },
    html: {
        animations: {
            onLoad: {
                shake: 'animation__shake',
                wobble: 'animation__wobble',
            },
        },
        buttons: {
            primary: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
            secondary: 'btn btn-secondary shadow-sm font-weight-bold mx-1 px-4',
            outlinePrimary: 'btn btn-outline-primary shadow-sm font-weight-bold mx-1 px-4',
            outlineSecondary: 'btn btn-outline-secondary shadow-sm font-weight-bold mx-1 px-4',
        },
        cards: {
            default: 'card border-0 shadow-lg rounded-lg',
        },
        badges: {
            micro: {
                fontSize: '0.65rem',
                letterSpacing: '0.5px',
                textTransform: 'uppercase',
            },
            info: 'badge-info',
            primary: 'badge-primary',
            warning: 'badge-warning',
            secondary: 'badge-secondary',
        },
        labels: {
            detailMicro: {
                fontSize: '0.7rem',
                letterSpacing: '0.5px',
            },
            mutedUpperFontWeightBoldDblockMb2: 'text-muted text-uppercase font-weight-bold d-block mb-2',
        },
        controls: {
            main: {
                menu: {
                    profile: {
                        img: {
                            id: 'mainMenuProfile'
                        },
                    },
                },
            },
        },
        popup: 'rounded-lg shadow border-0',
        space: {
            formatOne: '&nbsp;',
            formatTwo: '&nbsp;&nbsp;',
            formatThree: '&nbsp;&nbsp;&nbsp;',
            formatFour: '&nbsp;&nbsp;&nbsp;&nbsp;',
            formatFive: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
            formatSix: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
            formatSevent: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
            formatEight: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
            formatNine: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
            formatTen: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
            formatEleven: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
            formatTwelve: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
            formatThirteen: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
            formatFourTeen: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
            formatFiftTeen: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
            formatSixTeen: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
            formatSevenTeen: '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;',
        },
        dataTables: {
            formats: {
                bordered: 'table table-bordered',
                striped: 'table table-striped',
                small: 'table table-sm',
                smBordered: 'table table-sm table-bordered',
                smStriped: 'table table-sm table-striped',
                smStripedBordered: 'table table-sm table-striped table-bordered',
                stripedBordered: 'table table-striped table-bordered',
                tableResponsiveSm: 'table-responsive-sm',
                tableHoverW100Border0: 'table table-hover w-100 border-0',
            },
        },
    },
    icons: {
        faFa: {
            building: 'fa fa-building',
            calendarAlt: 'fa fa-calendar-alt',
            check: 'fa fa-check',
            checkCircle: 'fa fa-check-circle',
        },
        farFa: {
            addressCard: 'far fa-address-card',
            checkCircleFar: 'far fa-check-circle',
            circleNavIcon: 'far fa-circle nav-icon',
        },
        fasFa: {
            addressCard: 'fas fa-address-card',
            alignJustify: 'fas fa-align-justify',
            arrowCircleLeft: 'fas fa-arrow-alt-circle-left',
            angleDoubleDown: 'fas fa-angle-double-down',
            angleDoubleUp: 'fas fa-angle-double-up',
            angleLeftRight: 'right fas fa-angle-left',
            arrowAltCircleLeft: 'fas fa-arrow-alt-circle-left',
            arrowCircleRight: 'fas fa-arrow-circle-right',
            arrowCircleUp: 'fas fa-arrow-alt-circle-up',
            award: 'fas fa-award',
            bed: 'fas fa-bed',
            building: 'fas fa-building',
            bullhorn: 'fas fa-bullhorn',
            calculator: 'fas fa-calculator',
            calendarAlt: 'fas fa-calendar-alt',
            camera: 'fas fa-camera',
            car: 'fas fa-car',
            caretDown: 'fas fa-caret-down',
            caretLeft: 'fas fa-caret-left',
            caretRight: 'fas fa-caret-right',
            caretUp: 'fas fa-caret-up',
            certificate: 'fas fa-certificate',
            circleDotNavIcon: 'far fa-dot-circle nav-icon',
            chartArea: 'fas fa-chart-area',
            chartBar: 'fas fa-chart-bar',
            chartColumn: 'fas fa-chart-column',
            chartLine: 'fas fa-chart-line',
            chevronUp: 'fas fa-chevron-up',
            check: 'fas fa-check',
            checkCircle: 'fas fa-check-circle',
            checkSquare: 'fas fa-check-square',
            clock: 'fas fa-clock',
            cloudDownloadAlt: 'fas fa-cloud-download-alt',
            cloudUploadAlt: 'fas fa-cloud-upload-alt',
            close: 'fas fa-times',
            cog: 'fas fa-cog',
            cogs: 'fas fa-cogs',
            coins: 'fas fa-coins',
            collectionCash: 'fas fa-cash-register',
            comment: 'fas fa-comment-alt',
            creditCard: 'fas fa-credit-card',
            dataBase: 'fas fa-database',
            desktop: 'fas fa-desktop',
            dollarSign: 'fas fa-dollar-sign',
            edit: 'fas fa-edit',
            envelope: 'fas fa-envelope',
            eye: 'fas fa-eye',
            eyeSlash: 'far fa-eye-slash',
            exclamationTrinagle: 'fas fa-exclamation-triangle',
            fileAlt: 'fas fa-file-alt',
            fileContract: 'fas fa-file-contract',
            fileInvoice: 'fas fa-file-invoice',
            folderOpen: 'fas fa-folder-open',
            globeAmericas: 'fas fa-globe-americas',
            hashTag: 'fas fa-hashtag',
            idCard: 'fas fa-id-card',
            infoCircle: 'fas fa-info-circle',
            key: 'fas fa-key',
            laptop: 'fas fa-laptop',
            list: 'fas fa-list',
            listUl: 'fas fa-list-ul',
            lock: 'fas fa-lock',
            moon: 'fas fa-moon',
            phone: 'fas fa-phone-alt',
            plusCircle: 'fas fa-plus-circle',
            save: 'fas fa-save',
            server: 'fas fa-server',
            search: 'fas fa-search',
            searchPlus: 'fas fa-search-plus',
            shieldAlt: 'fas fa-shield-alt',
            shoppingCart: 'fas fa-shopping-cart',
            spellCheck: 'fas fa-spell-check',
            spinnerFaSpin: 'fas fa-spinner fa-spin',
            sun: 'fas fa-sun',
            th: 'fas fa-th',
            times: 'fas fa-times',
            timesCircle: 'fas fa-times-circle',
            toggleOn: 'fas fa-toggle-on',
            trash: 'fas fa-trash',
            user: 'fas fa-user',
            userEdit: 'fas fa-user-edit',
            userTag: 'fas fa-user-tag',
            userTie: 'fas fa-user-tie',
            userPlus: 'fas fa-user-plus',
            userShield: 'fas fa-user-shield',
            users: 'fas fa-users',
            usersCog: 'fas fa-users-cog',
        },
        ions: {
            bag: 'ion ion-bag',
            cash: 'ion ion-cash',
            creditCardFas: 'fas fa-credit-card',
            documentText: 'ion ion-document-text',
            list: 'ion ion-ios-list',
            listOutline: 'ion ion-ios-list-outline',
            people: 'ion ion-ios-people',
            personAdd: 'ion ion-person-add',
            personStalker: 'ion-person-stalker',
            pieGraph: 'ion ion-pie-graph',
            statsBar: 'ion ion-stats-bars',
            usd: 'ion ion-social-usd',
        },
        ellipsisV: 'fas fa-ellipsis-v',
        envelope: 'fas fa-envelope',
        envelopeOpenText: 'fas fa-envelope-open-text',
        eraser: 'fas fa-eraser',
        earthAmericasFa: 'fa fa-earth-americas',
        earthAmericasFas: 'fas fa-earth-americas',
        earthAmericasFar: 'far fa-earth-americas',
        eyeIpasswordIpassword: 'far fa-eye ipassword ipassword',
        eyeSlashIpasswordIpassword: 'far fa-eye-slash ipassword ipassword',
        eye: 'far fa-eye',
        eyeSlash: 'far fa-eye-slash',
        fax: 'fas fa-fax',
        fileAltFar: 'far fa-file-alt',
        fileFar: 'far fa-file',
        fileFas: 'fas fa-file',
        //fileLines: 'fa fa-file-lines',
        //fileTextFa: 'fas fa-file-text',
        //fileTextFas: 'fas fa-file-text',
        fileImageFas: 'fas fa-file-image',
        // fileInvoice: 'fas fa-file-invoice',
        folderOpen: 'fas fa-folder-open',
        glassCheers: 'fas fa-glass-cheers',
        globe: 'fas fa-globe',
        grin: 'far fa-grin',
        handHoldingUsd: 'fas fa-hand-holding-usd',
        headset: 'fas fa-headset',
        home: 'fas fa-home',
        houseUser: 'fas fa-house-user',
        icons: 'fas fa-icons',
        idBadge: 'fas fa-id-badge',
        idCard: 'fas fa-id-card',
        image: 'fas fa-image',
        images: 'fas fa-images',
        indentFasFa: 'fas fa-indent',
        invoiceDollar: 'fas fa-file-invoice-dollar',
        layerGroup: 'fas fa-layer-group',
        levelUp: 'fas fa-level-up-alt',
        listAlt: 'fas fa-list-alt',
        listOl: 'fas fa-list-ol',
        listTh: 'fas fa-th-list',
        listUl: 'fas fa-list-ul',
        mailBulk: 'fas fa-mail-bulk',
        mapMarker: 'fas fa-map-marker-alt',
        mapMarkedAlt: 'fas fa-map-marked-alt',
        minus: 'fas fa-minus',
        minusCircle: 'fas fa-minus-circle',
        mobileAlt: 'fas fa-mobile-alt',
        moneyBill: 'fa fa-money-bill',
        moneyCheckAlt: 'fas fa-money-check-alt',
        //moneyBillWave: 'fa fa-money-bill-wave',
        moneyBillWave: 'fas fa-money-bill-wave',
        notEqual: 'fas fa-not-equal',
        paperClip: 'fas fa-paperclip',
        paperPlane: 'fas fa-paper-plane',
        pauseCircle: 'fas fa-pause-circle',
        percentage: 'fas fa-percentage',
        phone: 'fa-solid fa-phone',
        piggyBank: 'fas fa-piggy-bank',
        powerOff: 'fas fa-power-off',
        print: 'fas fa-print',
        receipt: 'fas fa-receipt',
        tag: 'fas fa-tag',
        tags: 'fas fa-tags',
        tasksFasFa: 'fas fa-tasks',
        textHeight: 'fas fa-text-height',
        trashFasFa: 'fas fa-trash-alt',
        trashFarFa: 'far fa-trash-alt',
        triangleFasFa: 'fas fa-exclamation-triangle',
        robot: 'fas fa-robot',
        store: 'fas fa-store',
        sign: 'fas fa-sign',
        sortNumericDown: 'fas fa-sort-numeric-down',
        sortNumericUpAlt: 'fas fa-sort-numeric-up-alt',
        shareSquare: 'fas fa-share-square',
        square: 'fa fa-square',
        squareMinus: 'far fa-minus-square',
        stickyNote: 'far fa-sticky-note',
        stream: 'fas fa-stream',
        sync: 'fas fa-sync',
        usd: 'fa fa-dollar-sign',
        undoFasFa: 'fas fa-undo',
        university: 'fas fa-university',
        userCheck: 'fas fa-user-check',
        usersFasFa: 'fas fa-users',
        usersSlash: 'fas fa-users-slash',
        userEdit: 'fas fa-user-edit',
        userClock: 'fas fa-user-clock',
        userLock: 'fas fa-user-lock',
        voteYea: 'fas fa-vote-yea',
        windowRestoreFas: 'fas fa-window-restore',
        windowRestoreFar: 'far fa-window-restore',
    },
    images: {
        address: '/images/locationIcon.png',
        detailsIcon: '/images/detailsIcon.png',
        email: '/images/EmailIcon.png',
        facebook: '/images/facebookIcon.png',
        instagram: '/images/instagramIcon.png',
        itemsLogo: '/images/items.png',
        appLogo: '/images/logoApp.png',
        logoCompany: '/images/logoCompany.png',
        noImage: '/images/noImage.png',
        notificationsToast: '/images/NotificationToastsIcon.png',
        userLogin: '/images/UserIcon.png',
        passwordIcon02: '/images/passwordIcon02.png',
        phone: '/images/telephoneIcon.png',
        rateLogo: '/images/RatesIcon.png',
        rrss: '/images/RRSSIcon.png',
        supplierLogo: '/images/logoCompany.png',
        supplierLogoNoBackgroud: '/images/logoSinFondo.png',
        telegram: '/images/telegramIcon.png',
        twitter: '/images/twitterIcon.png',
        users: '/images/users.png',
        user: '/images/user.png',
        whatsApp: '/images/whatsAppIcon.png',
        icons: {
            analyst: '/images/icons/analyst.png',
            backupReviews: '/images/icons/backupReviews.png',
            bot: '/images/icons/bot.png',
            checkFalse: '/images/icons/checkFalse.png',
            checkSquare: '/images/icons/check.png',
            checkTrue: '/images/icons/checkTrue.png',
            comment: '/images/icons/comment.png',
            country: '/images/icons/country.png',
            company: '/images/icons/company.png',
            customers: '/images/icons/customers.png',
            dataCenters: '/images/icons/dataCenter.png',
            domainHostings: '/images/icons/domainHosting.png',
            dataProtection: '/images/icons/dataProtection.png',
            devices: '/images/icons/devices.png',
            email: '/images/icons/email.png',
            error404: '/images/icons/error404.png',
            forex: '/images/icons/forex.png',
            group: '/images/icons/group.png',
            info: '/images/icons/info.png',
            map: '/images/icons/map.png',
            newMessage: '/images/icons/newMessage.png',
            notificationsToasts: '/images/icons/notificationsToasts.png',
            parameters: '/images/icons/parameter.png',
            password: '/images/icons/password.png',
            paymentInformation: '/images/icons/paymentInformation.png',
            pdfAvailableIcon: '/images/icons/pdfDownloadAvailableIcon.png',
            pdfNoAvailableIcon: '/images/icons/pdfDownloadNoAvailableIcon.png',
            pricetag: '/images/icons/price-tag.png',
            purchse: '/images/icons/purchase.png',
            requirements: '/images/icons/requirement.png',
            remoteConnections: '/images/icons/remoteConnection.png',
            review: '/images/icons/review.png',
            services: '/images/icons/services.png',
            settings: '/images/icons/settings.png',
            siteMap: '/images/icons/site-map.png',
            // toggleOff: '/images/icons/toggleOff.png',
            // toggleOn: '/images/icons/toggleOn.png',
            toggleOff: '/images/icons/toggleOff_v5.png',
            toggleOn: '/images/icons/toggleOn_v5.png',
            smartphone: '/images/icons/smartphone.png',
            socialMedia: '/images/icons/socialMedia.png',
            status: '/images/icons/status.png',
            store: '/images/icons/store.png',
            systemAccesses: '/images/icons/systemAccesses.png',
            types: '/images/icons/type.png',
            user: '/images/icons/user.png',
        },
    },
    labels: {
        about: {
            en: 'About',
            es: 'Acerca de',
        },
        account: {
            en: 'Account',
            es: 'Cuenta',
        },
        accounts: {
            en: 'Accounts',
            es: 'Cuentas',
        },
        accountInformation: {
            en: 'Account information',
            es: 'Información de la cuenta',
        },
        active: {
            en: 'Active',
            es: 'Activa',
        },
        administrator: {
            en: 'Administrator',
            es: 'Administrador',
        },
        add: {
            en: 'Add',
            es: 'Agregar',
        },
        addDetail: {
            en: 'Add detail',
            es: 'Agregar detalle',
        },
        addDetails: {
            en: 'Add details',
            es: 'Agregar detalles',
        },
        addCompanyAbr: {
            en: 'Add Co.',
            es: 'Agr. Comp.',
        },
        addNewRate: {
            en: 'Add new rate',
            es: 'Agregar tasa nueva',
        },
        address: {
            en: 'Address',
            es: 'Dirección',
        },
        alreadyRegistered: {
            en: 'Already registered?',
            es: '¿Ya está registrado?',
        },
        allUsers: {
            en: 'All users',
            es: 'Todos los usuarios',
        },
        analyst: {
            en: 'Analyst',
            es: 'Analista',
        },
        analysts: {
            en: 'Analysts',
            es: 'Analistas',
        },
        applyTo: {
            en: 'Apply to',
            es: 'Aplicar a',
        },
        assigRole: {
            en: 'Assig role',
            es: 'Role asignado',
        },
        authorizate: {
            en: 'Authorizate',
            es: 'Autorizar',
        },
        authorized: {
            en: 'Authorized',
            es: 'Autorizado',
        },
        authorizedBy: {
            en: 'Authorized by',
            es: 'Autorizado por',
        },
        authUser: {
            en: 'Auth. user',
            es: 'Autor. usuario',
        },
        authenticated: {
            en: 'Authenticated',
            es: 'Autenticado',
        },
        availableCredit: {
            en: 'Available credit',
            es: 'Crédito disponible',
        },
        availableQuantity: {
            en: 'Available quantity',
            es: 'Cantidad disponible',
        },
        approvalDone: {
            en: 'Approval done',
            es: 'Aprobación realizada',
        },
        back: {
            en: 'Back',
            es: 'Volver',
        },
        backToHome: {
            en: 'Back to home',
            es: 'Volver al inicio',
        },
        backupReview: {
            en: 'Backup review',
            es: 'Revisión respaldo',
        },
        backupReviewDetail: {
            en: 'Backup review detail',
            es: 'Detalle revisión respaldo',
        },
        backupReviews: {
            en: 'Backup reviews',
            es: 'Revisión respaldos',
        },
        backupReviewDetails: {
            en: 'Backup review details',
            es: 'Detalles revisión respaldos',
        },
        balance: {
            en: 'Balance',
            es: 'Saldo',
        },
        balanceDocument: {
            en: 'Balance document',
            es: 'Saldo documento',
        },
        balanceDocumentAbr: {
            en: 'Bal. doc.',
            es: 'Sal. doc.',
        },
        balanceDocuments: {
            en: 'Balance documents',
            es: 'Saldo documentos',
        },
        balanceDocumentsAbr: {
            en: 'Bal. docs',
            es: 'Sal. docts',
        },
        balanceOther: {
            en: 'Balance other',
            es: 'Saldo otro',
        },
        balanceOtherAbr: {
            en: 'Bal. oth.',
            es: 'Sal. ot.',
        },
        balanceOthers: {
            en: 'Balance others',
            es: 'Saldo otros',
        },
        balanceOthersAbr: {
            en: 'Bal. oths.',
            es: 'Sal. ots.',
        },
        beginDate: {
            en: 'Begin date',
            es: 'Fecha inicio',
        },
        billToPay: {
            en: 'Bill to pay',
            es: 'Cuenta por pagar',
        },
        bot: {
            en: 'Bot',
            es: 'Robot',
        },
        bots: {
            en: 'Bots',
            es: 'Robots',
        },
        buyer: {
            en: 'Buyer',
            es: 'Comprador',
        },
        cancel: {
            en: 'Cancel',
            es: 'Cancelar',
        },
        canceled: {
            en: 'Canceled',
            es: 'Cancelado',
        },
        category: {
            en: 'Category',
            es: 'Categoría',
        },
        categories: {
            en: 'Categories',
            es: 'Categorías',
        },
        clickToChangePicture: {
            en: 'Click to change picture',
            es: 'Clic para cambiar la imagen',
        },
        close: {
            en: 'Close',
            es: 'Cerrar',
        },
        code: {
            en: 'Code',
            es: 'Código',
        },
        company: {
            en: 'Company',
            es: 'Empresa',
        },
        companies: {
            en: 'Companies',
            es: 'Empresas',
        },
        companiesAccess: {
            en: 'Companies access',
            es: 'Accesos empresas',
        },
        companyEmail: {
            en: 'Company email',
            es: 'Correo empresa',
        },
        configuration: {
            en: 'Configuration',
            es: 'Configuración',
        },
        configurations: {
            en: 'Configurations',
            es: 'Configuraciones',
        },
        confrEmail: {
            en: 'Confr. email',
            es: 'Confir. correo',
        },
        confirmationDone: {
            en: 'Confirmation done',
            es: 'Confirmación realizada',
        },
        confirmNewPassword: {
            en: 'Confirm new password',
            es: 'Confirmar contraseña nueva',
        },
        controller: {
            en: 'Controller',
            es: 'Controlador',
        },
        controlNumber: {
            en: 'Control number',
            es: 'Número control',
        },
        cost: {
            en: 'Cost',
            es: 'Costo',
        },
        costs: {
            en: 'Costs',
            es: 'Costos',
        },
        country: {
            en: 'Country',
            es: 'País',
        },
        countries: {
            en: 'Countries',
            es: 'Paises',
        },
        create: {
            en: 'Create',
            es: 'Crear',
        },
        created: {
            en: 'Created',
            es: 'Creado',
        },
        createds: {
            en: 'Createds',
            es: 'Creados',
        },
        createOne: {
            en: 'Create One',
            es: 'Crear una',
        },
        creditAssigned: {
            en: 'Credit assignet',
            es: 'Crédito asignado'
        },
        creditRequested: {
            en: 'Credit requested',
            es: 'Crédito solicitado'
        },
        calculateRates: {
            en: 'calculate rates',
            es: 'Calcular tasa',
        },
        channels: {
            en: 'Channels',
            es: 'Canales',
        },
        changePassword: {
            en: 'Change password',
            es: 'Cambiar contraseña',
        },
        checkRegistrationStatus: {
            en: 'Check registration status',
            es: 'Consultar estado de registro',
        },
        clearTokenLogs: {
            en: 'Clear token logs',
            es: 'Borrar registros de token',
        },
        comment: {
            en: 'Comment',
            es: 'Comentario',
        },
        commentary: {
            en: 'Commentary',
            es: 'Comentario',
        },
        commentaryAbr: {
            en: 'Comm.',
            es: 'Coment.',
        },
        companyData: {
            en: 'Company Data',
            es: 'Datos de la empresa',
        },
        companyInformation: {
            en: 'Company information',
            es: 'Información de la empresa',
        },
        companyInformationAbr: {
            en: 'Company inf.',
            es: 'Info. de la empresa',
        },
        contact: {
            en: 'Contact',
            es: 'Contacto',
        },
        contactPerson: {
            en: 'Contact person',
            es: 'Persona contacto',
        },
        createNew: 'Create new',
        customer: {
            en: 'Customer',
            es: 'Cliente',
        },
        customerData: {
            en: 'Customer Data',
            es: 'Datos del cliente',
        },
        customers: {
            en: 'Customers',
            es: 'Clientes',
        },
        currencies: {
            en: 'Currencies',
            es: 'Monedas',
        },
        currency: {
            en: 'Currency',
            es: 'Moneda',
        },
        currentPassword: {
            en: 'Current password',
            es: 'Contraseña actual',
        },
        danger: {
            en: 'Danger',
            es: 'Peligro',
        },
        dataCenter: {
            en: 'Data center',
            es: 'Centro de dato',
        },
        dataCenters: {
            en: 'Data centers',
            es: 'Centro de datos',
        },
        date: {
            en: 'Date',
            es: 'Fecha',
        },
        dateTime: {
            en: 'Date / time',
            es: 'Fecha / hora',
        },
        day: {
            en: 'Day',
            es: 'Día',
        },
        daysToExpire: {
            en: 'Days to expire',
            es: 'Días por vencer',
        },
        daysToExpireAbr: {
            en: 'DTE',
            es: 'DPV',
        },
        daysToExpireAbr2: {
            en: 'Days to exp.',
            es: 'Días por ven.',
        },
        default: {
            en: 'Default',
            es: 'Por defecto'
        },
        delete: {
            en: 'Delete',
            es: 'Eliminar'
        },
        deleted: {
            en: 'Deleted',
            es: 'Eliminado',
        },
        deleteAccount: {
            en: 'Delete account',
            es: 'Eliminar cuenta',
        },
        department: {
            en: 'Department',
            es: 'Departamento',
        },
        description: {
            en: 'Description',
            es: 'Descripción',
        },
        detail: {
            en: 'Detail',
            es: 'Detalle',
        },
        details: {
            en: 'Details',
            es: 'Detalles',
        },
        // detailCompanyCustomers: {
        //     en: 'Details - (company / customer)',
        //     es: 'Detalles - (compañia / clientes)',
        // },
        detailCompanyCustomers: {
            en: 'Details - (company - customer)',
            es: 'Detalles - (compañia - clientes)',
        },
        detailDocuments: {
            en: 'Detail documents',
            es: 'Detalle documentos',
        },
        detailStatementAccounts: {
            en: 'Detail statement accounts',
            es: 'Detalles estado de cuenta',
        },
        device: {
            en: 'Device',
            es: 'Dispositivo',
        },
        devices: {
            en: 'Devices',
            es: 'Dispositivos',
        },
        digitizedDocument: {
            en: 'Digitized document',
            es: 'Documentos digitalizado',
        },
        digitizedDocuments: {
            en: 'Digitized documents',
            es: 'Documentos digitalizados',
        },
        disabled: {
            en: 'Disabled',
            es: 'Deshabilitado',
        },
        displayName: 'Display name',
        document: {
            en: 'Document',
            es: 'Documento',
        },
        documents: {
            en: 'Documents',
            es: 'Documentos',
        },
        documentDetail: {
            en: 'Document detail',
            es: 'Detalle documento',
        },
        documentDetails: {
            en: 'Document details',
            es: 'Detalle documentos',
        },
        documentInformation: {
            en: 'Document information',
            es: 'Información documento',
        },
        documentInformations: {
            en: 'Document informations',
            es: 'Información documentos',
        },
        domain: {
            en: 'Domain',
            es: 'Dominio',
        },
        domainHosting: {
            en: 'Domain hosting',
            es: 'Alojamiento de dominio',
        },
        domainHostings: {
            en: 'Domain hostings',
            es: 'Alojamiento de dominios',
        },
        dontHaveAnAccount: {
            en: `Don't have an account?`,
            es: '¿No tiene cuenta?',
        },
        download: {
            en: 'Download',
            es: 'Descargar',
        },
        edit: {
            en: 'Edit',
            es: 'Editar',
        },
        edited: {
            en: 'Edited',
            es: 'Editado',
        },
        editeds: {
            en: 'Editeds',
            es: 'Editados',
        },
        email: {
            en: 'Email',
            es: 'Correo',
        },
        emailConfi: {
            en: 'Email confi.',
            es: 'Correo confir.',
        },
        emails: {
            en: 'Emails',
            es: 'Correos',
        },
        emision: {
            en: 'Emision',
            es: 'Emisión',
        },
        emoji: {
            en: 'Emoji',
            es: 'Emoji',
        },
        emojis: {
            en: 'Emojis',
            es: 'Emojis',
        },
        enabled: {
            en: 'Enabled',
            es: 'Habilitado',
        },
        end: {
            en: 'End',
            es: 'Fin',
        },
        enterYourEmailCheckStatus: 'Enter your email to check status',
        enterYourEmail: {
            en: 'Enter your email',
            es: 'Ingrese su correo',
        },
        error: {
            en: 'Error',
            es: 'Error',
        },
        event: {
            en: 'Event',
            es: 'Evento',
        },
        events: {
            en: 'Events',
            es: 'Eventos',
        },
        executionDate: {
            en: 'Execution date',
            es: 'Fecha ejecución',
        },
        expiration: {
            en: 'Expiration',
            es: 'Vencimiento',
        },
        expiredDays: {
            en: 'Expired days',
            es: 'Días vencidos',
        },
        expiredDaysAbr: {
            en: 'EPD',
            es: 'DVC',
        },
        expiredDaysAbr2: {
            en: 'Exp. days',
            es: 'Días ven.',
        },
        file: {
            en: 'File',
            es: 'Archivo',
        },
        fax: {
            en: 'Fax',
            es: 'Fax',
        },
        files: {
            en: 'Files',
            es: 'Archivos',
        },
        finalized: {
            en: 'Finalized',
            es: 'Finalizado',
        },
        firstName: {
            en: 'First name',
            es: 'Nombre',
        },
        flag: {
            en: 'Flag',
            es: 'Bandera',
        },
        flags: {
            en: 'Flags',
            es: 'Banderas',
        },
        fullName: {
            en: 'Full name',
            es: 'Nombre y apellido',
        },
        forgotYourPassword: {
            en: 'Forgot your password?',
            es: '¿Olvidaste tu contraseña?'
        },
        forgotPassword: {
            en: 'Forgot password',
            es: 'Contraseña olvidada'
        },
        from: {
            en: 'From',
            es: 'Desde',
        },
        getExcel: {
            en: 'Get excel',
            es: 'Obtener excel',
        },
        getToken: {
            en: 'Get token',
            es: 'Obtener token',
        },
        getSites: {
            en: 'Get sites',
            es: 'Obtener sitios',
        },
        getUserInfo: {
            en: 'Get user info',
            es: 'obtener información del usuario',
        },
        hello: {
            en: 'Hello',
            es: 'Hola',
        },
        hidePassword: {
            en: 'Hide password',
            es: 'Ocultar contraseña',
        },
        home: {
            en: 'Home',
            es: 'Inicio',
        },
        id: {
            en: 'Id',
            es: 'Id',
        },
        identityCard: {
            en: 'Identity card',
            es: 'Cédula identidad',
        },
        image: {
            en: 'Image',
            es: 'Imagen',
        },
        images: {
            en: 'Images',
            es: 'Imagenes',
        },
        inProcess: {
            en: 'In process',
            es: 'En proceso',
        },
        item: {
            en: 'Item',
            es: 'Artículo',
        },
        items: {
            en: 'Items',
            es: 'Artículos',
        },
        inactive: {
            en: 'Inactive',
            es: 'Inactivo',
        },
        index: {
            en: 'Index',
            es: 'Índice',
        },
        information: {
            en: 'Information',
            es: 'Información',
        },
        informCreation: {
            en: 'Inform creation',
            es: 'Informar creación',
        },
        informCreationUser: {
            en: 'Inform creation user',
            es: 'Informar usuario de creación',
        },
        informCompletion: {
            en: 'Inform completion',
            es: 'Informar finalización',
        },
        informationDocument: {
            en: 'Information document',
            es: 'Documento informativo',
        },
        informationDocuments: {
            en: 'Information documents',
            es: 'Documentos informativos',
        },
        interestRate: {
            en: 'Interest rate',
            es: 'Cuota de interés',
        },
        isActive: {
            en: 'Is active',
            es: 'Está activa',
        },
        isAvailable: {
            en: 'Is available',
            es: 'está disponible',
        },
        isAuthenticated: {
            en: 'Is authenticated',
            es: 'Está autenticado',
        },
        quickRequest: {
            en: 'Quick request',
            es: 'Consulta rápida',
        },
        latestPostsCreated: {
            en: 'Latest posts created',
            es: 'Últimas publicaciones creadas',
        },
        lastName: {
            en: 'Last name',
            es: 'Apellidos',
        },
        lineReturn: {
            en: 'Line return',
            es: 'Retorno de línea',
        },
        listingTypeId: {
            en: 'Listing type Id',
            es: 'Tipo de publicación'
        },
        legend: {
            en: 'Legend',
            es: 'Leyenda',
        },
        legends: {
            en: 'Legends',
            es: 'Leyendas',
        },
        loading: {
            en: 'Loading',
            es: 'Cargando',
        },
        loan: {
            en: 'Loan',
            es: 'Préstamo',
        },
        loans: {
            en: 'Loans',
            es: 'Préstamos',
        },
        login: {
            en: 'Login',
            es: 'Iniciar sesión',
        },
        loginWithSocial: {
            en: 'Login With Social',
            es: 'Iniciar sesión con redes sociales',
        },
        logo: {
            en: 'Logo',
            es: 'Logo',
        },
        logOut: {
            en: 'Log out',
            es: 'Cerrar sesión',
        },
        logOff: {
            en: 'Log off',
            es: 'Desconectar',
        },
        main: {
            en: 'Main',
            es: 'Principal',
        },
        mark: {
            en: 'Mark',
            es: 'Marca',
        },
        message: {
            en: 'Message',
            es: 'Mensaje',
        },
        method: {
            en: 'Method',
            es: 'Método',
        },
        metric: {
            en: 'Metric',
            es: 'Métrica',
        },
        metrics: {
            en: 'Metrics',
            es: 'Métricas',
        },
        model: {
            en: 'Model',
            es: 'Modelo',
        },
        module: {
            en: 'Module',
            es: 'Módulo',
        },
        monitorRequest: {
            en: 'Monitor request',
            es: 'Monitorear solicitud',
        },
        moreInfo: {
            en: 'More info',
            es: 'Más info',
        },
        myEmailDomainCom: {
            en: 'myEmail@domain.com',
            es: 'miCorreo@dominio.com',
        },
        name: {
            en: 'Name',
            es: 'Nombre',
        },
        newPassword: {
            en: 'New password',
            es: 'Contraseña nueva',
        },
        net: {
            en: 'Net',
            es: 'Neto',
        },
        netAmountDocument: {
            en: 'Net amount document',
            es: 'Monto neto documento',
        },
        netAmountDocumentAbr: {
            en: 'Net amount doc.',
            es: 'Monto neto doc.',
        },
        netAmountDocuments: {
            en: 'Net amount documents',
            es: 'Monto neto documentos',
        },
        netAmountDocumentsAbr: {
            en: 'Net amount docs.',
            es: 'Monto neto docs.',
        },
        netAmountOther: {
            en: 'Net amount other',
            es: 'Monto neto otro',
        },
        netAmountOtherAbr: {
            en: 'Net amount oth.',
            es: 'Monto neto ot.',
        },
        netAmountOthers: {
            en: 'Net amount others',
            es: 'Monto neto otros',
        },
        netAmountOthersAbr: {
            en: 'Net amount oths.',
            es: 'Monto neto ots.',
        },
        newPrice: {
            en: 'New price',
            es: 'Precio nuevo',
        },
        nit: {
            en: 'N.I.T.',
            es: 'N.I.T.',
        },
        nickName: {
            en: 'Nick name',
            es: 'Seudónimo',
        },
        no: {
            en: 'No',
            es: 'No',
        },
        notFound: {
            en: 'Not found',
            es: 'No encontrado',
        },
        notification: {
            en: 'Notification',
            es: 'Notificación',
        },
        notifications: {
            en: 'Notifications',
            es: 'Notificaciones',
        },
        notificationsToast: {
            en: 'Notifications (toast)',
            es: 'Notificaciones (toast)'
        },
        number: {
            en: 'Number',
            es: 'Número'
        },
        numbers: {
            en: 'Numbers',
            es: 'Números'
        },
        observation: {
            en: 'Observation',
            es: 'Observación',
        },
        observations: {
            en: 'Observations',
            es: 'Observaciones',
        },
        order: {
            en: 'Order',
            es: 'Pedido',
        },
        orders: {
            en: 'Orders',
            es: 'Pedidos',
        },
        pagined: {
            en: 'Pagined',
            es: 'Paginado',
        },
        paginated: {
            en: 'Paginated',
            es: 'Paginado',
        },
        parameter: {
            en: 'Parameter',
            es: 'Parámetro',
        },
        parameters: {
            en: 'Parameters',
            es: 'Parámetros',
        },
        parameterDetail: {
            en: 'Parameter detail',
            es: 'Parámetro detalle',
        },
        parameterDetails: {
            en: 'Parameter details',
            es: 'Parámetros detalles',
        },
        password: {
            en: 'Password',
            es: 'Contraseña',
        },
        passwordConfirm: {
            en: 'Password confirm',
            es: 'confirmar contraseña',
        },
        paymentInformation: {
            en: 'Payment information',
            es: 'Información de pago',
        },
        paymentInformations: {
            en: 'Payment informations',
            es: 'Información de pagos',
        },
        paymentInformationDetail: {
            en: 'Payment information detail',
            es: 'Detalle información de pago',
        },
        paymentInformationDetails: {
            en: 'Payment information details',
            es: 'Detalle Información de pagos',
        },
        pending: {
            en: 'Pending',
            es: 'Pendiente',
        },
        phone: {
            en: 'Phone',
            es: 'Teléfono',
        },
        phones: {
            en: 'Phones',
            es: 'Teléfonos',
        },
        phoneNumber: {
            en: 'Phone number',
            es: 'Número de teléfonor',
        },
        personalInformation: {
            en: 'Personal information',
            es: 'Información personal',
        },
        position: {
            en: 'Position',
            es: 'Cargo',
        },
        priceOtherCurrency: {
            en: 'Price other currency',
            es: 'Precio otra moneda',
        },
        price: {
            en: 'Price',
            es: 'Precio',
        },
        priceML: {
            en: 'Price ML',
            es: 'Precio ML',
        },
        priceOC: {
            en: 'Price OC',
            es: 'Precio OM',
        },
        primaryIp: {
            en: 'Primary IP',
            es: 'IP Primaria',
        },
        primaryMacAddress: {
            en: 'Primary MAC Address',
            es: 'Dirección MAC Primaria',
        },
        primaryDNS: {
            en: 'Primary DNS',
            es: 'DNS Primario',
        },
        privacy: {
            en: 'Privacy',
            es: 'Privacidad'
        },
        privacyPolicy: {
            en: 'Privacy policy',
            es: 'Política de privacidad',
        },
        privacyAndConditions: {
            en: 'Privacy and conditions',
            es: 'Privacidad y condiciones',
        },
        process: {
            en: 'Process',
            es: 'Proceso',
        },
        processing: {
            en: 'Processing',
            es: 'Procesando',
        },
        processesCompletedSuccessfully: {
            en: 'Processes completed successfully',
            es: 'Procesos completados con éxito',
        },
        profile: {
            en: 'Profile',
            es: 'Perfil',
        },
        protectedByReCAPTCHA: {
            en: 'Protected by reCAPTCHA',
            es: 'Protegido por reCAPTCHA',
        },
        purchase: {
            en: 'Purchase',
            es: 'Compra',
        },
        purchases: {
            en: 'Purchases',
            es: 'Compras',
        },
        quantity: {
            en: 'Quantity',
            es: 'Cantidad',
        },
        question: {
            en: 'Question',
            es: 'Pregunta',
        },
        rate: {
            en: 'Rate',
            es: 'Tasa',
        },
        rates: {
            en: 'Rates',
            es: 'Tasas',
        },
        ratesVariations: {
            en: 'Rates variations',
            es: 'Variaciones de tasa',
        },
        reAuthentication: {
            en: 'Re Authentication',
            es: 'Re autenticación',
        },
        recoverPassword: {
            en: 'Recover password',
            es: 'Recuperar contraseña',
        },
        registerDate: {
            en: 'Register date',
            es: 'Fecha de registro',
        },
        registerNewMembership: {
            en: 'Register a new membership',
            es: 'Registrar una nueva membresía',
        },
        registerStatus: {
            en: 'Register status',
            es: 'Estatus registro',
        },
        register: {
            en: 'Register',
            es: 'Registrar',
        },
        registered: {
            en: 'Registered',
            es: 'Registrada',
        },
        registry: {
            en: 'Registry',
            es: 'Registro',
        },
        report: {
            en: 'Report',
            es: 'Reporte',
        },
        reports: {
            en: 'Reports',
            es: 'Reportes',
        },
        requirement: {
            en: 'Requirement',
            es: 'Requerimiento',
        },
        requirements: {
            en: 'Requirements',
            es: 'Requerimientos',
        },
        rememberMe: {
            en: 'Remember me?',
            es: '¿Recordarme?',
        },
        remoteConnection: {
            en: 'Remote connection',
            es: 'Conexión remota',
        },
        remoteConnectionAbr: {
            en: 'Rem. con. (DNS)',
            es: 'Con. rem. (DNS)',
        },
        remoteConnections: {
            en: 'Remote connections',
            es: 'Conexiónes remotas',
        },
        registrationDone: {
            en: 'Registration done',
            es: 'Registro realizado',
        },
        request: {
            en: 'Request',
            es: 'Consultar',
        },
        requestAccount: {
            en: 'Request account',
            es: 'Solicitar cuenta',
        },
        requestAccountDetails: {
            en: 'Request account details',
            es: 'Detalles solicitar cuenta',
        },
        requestAccountMonitor: {
            en: 'Request account monitor',
            es: 'Monitor solicitar cuenta',
        },
        result: {
            en: 'Result',
            es: 'Resultado',
        },
        results: {
            en: 'Results',
            es: 'Resultados',
        },
        rif: {
            en: 'R.I.F.',
            es: 'R.I.F.',
        },
        role: {
            en: 'Role',
            es: 'Rol',
        },
        roleAssignmentDone: {
            en: 'Role assignment done',
            es: 'Asignación de role realizada',
        },
        row: {
            en: 'Row',
            es: 'Fila',
        },
        rows: {
            en: 'Rows',
            es: 'Filas',
        },
        sale: {
            en: 'Sale',
            es: 'Venta',
        },
        sales: {
            en: 'Sales',
            es: 'Ventas',
        },
        save: {
            en: 'Save',
            es: 'Guardar',
        },
        scheduledDate: {
            en: 'Scheduled date',
            es: 'Fecha programada',
        },
        secondaryIp: {
            en: 'Secondary IP',
            es: 'IP Secundaria',
        },
        secondaryMacAddress: {
            en: 'Secondary MAC Address',
            es: 'Dirección MAC Secundaria',
        },
        secondaryDNS: {
            en: 'Secondary DNS',
            es: 'DNS Secundario',
        },
        seeAllPosts: {
            en: 'See all posts',
            es: 'Ver todas las publicaciones'
        },
        seeAllRates: {
            en: 'See all rates',
            es: 'Ver todas las tasas'
        },
        seeItems: {
            en: 'See items',
            es: 'Ver artículos',
        },
        search: {
            en: 'Search',
            es: 'Buscar',
        },
        secondId: {
            en: 'Second id',
            es: 'Id secundario',
        },
        selectRole: 'Select a role',
        seller: {
            en: 'Seller',
            es: 'Vendedor',
        },
        send: {
            en: 'Send',
            es: 'Enviar',
        },
        serial: {
            en: 'Serial',
            es: 'Serial',
        },
        service: {
            en: 'Service',
            es: 'Servicio',
        },
        serviceDocument: {
            en: 'Service document',
            es: 'Documento servicio',
        },
        serviceDocuments: {
            en: 'Service documents',
            es: 'Documentos servicio',
        },
        services: {
            en: 'Services',
            es: 'Servicios',
        },
        servicesTitles: {
            backupReviews: {
                en: 'Service copies, tests and restoration of data / information',
                es: 'Servicio copias, pruebas y restauración de datos / información',
            },
            dataCenters: {
                en: 'Data center service, process scalability and access on demand',
                es: 'Servicio centro de datos, escalabilidad de procesos y accesos según demanda',
            },
            devices: {
                en: 'Connection parameters and access to network devices, domain accounts and e-mails',
                es: 'Parámetros de conexión y acceso a los dispositvos de red, cuentas de dominio y correos',
            },
            domainHostings: {
                en: 'Domain hosting service, web pages, web services',
                es: 'Servicio alojamiento de dominios, páginas web, servicios web',
            },
            remoteConnectionDNS: {
                en: 'Remote connection services, DNS, VPN, web access to local resources',
                es: 'Servicios conexión remota, DNS, VPN, acceso web a recursos locales',
            },
        },
        session: {
            en: 'Session',
            es: 'Sesión',
        },
        settings: {
            es: 'Configuraciones',
            en: 'Settings',
        },
        showPassword: {
            en: 'Show password',
            es: 'Mostrar contraseña',
        },
        signIn: {
            en: 'Sign in',
            es: 'iniciar sesión',
        },
        signInToStartYourSession: {
            en: 'Sign in to start your session',
            es: 'Regístrese para iniciar su sesión',
        },
        sincerely: {
            en: 'Sincerely',
            es: 'Atentamente',
        },
        site: {
            en: 'Site',
            es: 'Sitio',
        },
        siteDetails: {
            en: 'Site details',
            es: 'Detalles sitio',
        },
        sites: {
            en: 'Sites',
            es: 'Sitios',
        },
        start: {
            en: 'Start',
            es: 'Inicio',
        },
        statementAccount: {
            en: 'Statement account',
            es: 'Estado de cuenta',
        },
        status: {
            en: 'Status',
            es: 'Estado',
        },
        socialNetworks: {
            en: 'Social netwroks',
            es: 'Redes sociales',
        },
        subCategories: {
            en: 'Subcategories',
            es: 'Subcategorías',
        },
        subCategory: {
            en: 'Subcategory',
            es: 'Subcategoría',
        },
        subject: {
            en: 'Subject',
            es: 'Asunto',
        },
        subTotal: {
            en: 'Sub total',
            es: 'Sub total',
        },
        success: {
            en: 'Success',
            es: 'Éxito',
        },
        sync: {
            en: 'Sync',
            es: 'Sincronizar',
        },
        synchronizeItems: {
            en: 'Synchronize items',
            es: 'Sincronizar artículos',
        },
        systemAccess: {
            en: 'System access',
            es: 'Acceso sistema',
        },
        systemAccesses: {
            en: 'System accesses',
            es: 'Accesos sistema',
        },
        systemAdministratorMustApproveAccount: {
            en: 'A system administrator must approve your account',
            es: 'Un administrador del sistema debe aprobar su cuenta',
        },
        systemAdministratorMustAssignYouRole: {
            en: 'A system administrator must assign you a role',
            es: 'Un administrador del sistema debe asignarle un rol',
        },
        systemAdministratorAssignedRole: {
            en: 'The system administrator assigned your role',
            es: 'El administrador del sistema asignó su rol',
        },
        tab: {
            en: 'Tab',
            es: 'Tabulador'
        },
        telegram: {
            en: 'Telegram',
            es: 'Telegram',
        },
        theUserHasAlReadyConfirmedEmail: {
            en: 'The user has already confirmed the email',
            es: 'El usuario ya ha confirmado el correo electrónico',
        },
        theSystemAdministratorApprovedAccount: {
            en: 'The system administrator approved your account',
            es: 'El administrador del sistema aprobó su cuenta',
        },
        theUserHasAlreadyMadeRegistration: {
            en: 'The user has already made the registration',
            es: 'El usuario ya ha realizado el registro.',
        },
        thisUser: {
            en: 'This user',
            es: 'Este usuario',
        },
        time: {
            en: 'Time',
            es: 'Hora',
        },
        title: {
            en: 'Title',
            es: 'Título',
        },
        total: {
            en: 'Total',
            es: 'Total',
        },
        to: {
            en: 'To',
            es: 'Hasta',
        },
        totals: {
            en: 'Totals',
            es: 'Totales',
        },
        type: {
            en: 'Type',
            es: 'Tipo',
        },
        types: {
            en: 'Types',
            es: 'Tipos',
        },
        user: {
            en: 'User',
            es: 'Usuario',
        },
        userEmail: {
            en: 'User email',
            es: 'Correo usuario',
        },
        userCode: {
            en: 'User code',
            es: 'Código usuario',
        },
        userCompanyDetails: {
            en: 'User company details',
            es: 'Detalle empresas usuario',
        },
        userId: {
            en: 'User Id',
            es: 'Id usuario',
        },
        users: {
            es: 'Usuarios',
            en: 'Users',
        },
        userName: {
            en: 'User name',
            es: 'Nombre de usuario',
        },
        undefined: {
            en: 'Undefined',
            es: 'Indefinido',
        },
        update: {
            en: 'Update',
            es: 'Actualizar',
        },
        updateCustomers: {
            en: 'Update customers',
            es: 'Actualizar clientes',
        },
        updateCustomersAbr: {
            en: 'Upd. cus.',
            es: 'Act. cli.',
        },
        yes: {
            en: 'Yes',
            es: 'Si'
        },
        youCanNowLogIntoOurSystemWithCredentials: {
            en: 'You can now log into our system with your credentials',
            es: 'Ya puedes iniciar sesion a nuestro sistema con tus credenciales'
        },
        youMustFinishAboveProcessesAccessSystem: {
            en: 'You must finish the above processes to access the system',
            es: 'Debe finalizar los procesos anteriores para acceder al sistema',
        },
        VerfEmail: {
            en: 'Verf. email',
            es: 'Verif. Correo',
        },
        viewAllRates: {
            en: 'View all rates',
            es: 'Ver todas las tasas',
        },
        visitDate: {
            en: 'Visit date',
            es: 'Día visita',
        },
        waitingConfirmation: {
            en: 'Waiting confirmation',
            es: 'Esperando confimación',
        },
        waitingApproval: {
            en: 'Waiting for approval',
            es: 'A la espera de aprobación',
        },
        waitingAssignRole: {
            en: 'Waiting to assign role',
            es: 'A la espera de asignar un rol',
        },
        waitingPreviousProcesses: {
            en: 'Waiting for previous processes',
            es: 'En espera de procesos anteriores',
        },
        warning: {
            en: 'Warning',
            es: 'Advertencia',
        },
        webSite: {
            en: 'Web site',
            es: 'Página web',
        },
        wellcomeEmail: {
            en: 'Wellcome email',
            es: 'Correo bienvenida',
        },
    },
    languages: {
        en: {
            code: 'en',
            id: 'en',
            format: {
                date: {
                    f1: 'm/d/y',
                    f2: 'm-d-y',
                    f3: 'mm/dd/yy',
                    f4: 'mm-dd-yy',
                    f5: 'mm/dd/yyyy',
                    f6: 'mm-dd-yyyy',
                    f7: 'M/D/Y',
                    f8: 'M-D-Y',
                    f9: 'MM/DD/YY',
                    f10: 'MM-DD-YY',
                    f11: 'MM/DD/YYYY',
                    f12: 'MM-DD-YYYY',
                    f13: 'YYYY-MM-DD',
                },
                time: {
                    f1: 'HH:mm',
                    f2: 'HH:mm:ss',
                    f3: 'hh:mm a',
                    f4: 'hh:mm:ss a',
                    picker: {
                        hhmm: 'HH:mm',
                        hhmmss: 'HH:mm:ss',
                    },
                    type: 24,
                },
            },
            numbers: {
                separators: {
                    decimals: '.',
                    thousands: ',',
                },
            },
        },
        enUS: {
            code: 'en-US',
            id: 'en',
            format: {
                date: {
                    f1: 'm/d/y',
                    f2: 'm-d-y',
                    f3: 'mm/dd/yy',
                    f4: 'mm-dd-yy',
                    f5: 'mm/dd/yyyy',
                    f6: 'mm-dd-yyyy',
                    f7: 'M/D/Y',
                    f8: 'M-D-Y',
                    f9: 'MM/DD/YY',
                    f10: 'MM-DD-YY',
                    f11: 'MM/DD/YYYY',
                    f12: 'MM-DD-YYYY',
                    f13: 'YYYY-MM-DD',
                },
                time: {
                    f1: 'HH:mm',
                    f2: 'HH:mm:ss',
                    f3: 'hh:mm a',
                    f4: 'hh:mm:ss a',
                    picker: {
                        hhmm: 'HH:mm',
                        hhmmss: 'HH:mm:ss',
                    },
                    type: 24,
                },
            },
            numbers: {
                separators: {
                    decimals: '.',
                    thousands: ',',
                },
            },
        },
        es: {
            code: 'es',
            id: 'es',
            format: {
                date: {
                    f1: 'd/m/y',
                    f2: 'd-m-y',
                    f3: 'dd/mm/yy',
                    f4: 'dd-mm-yy',
                    f5: 'dd/mm/yyyy',
                    f6: 'dd-mm-yyyy',
                    f7: 'D/M/Y',
                    f8: 'D-M-Y',
                    f9: 'DD/MM/YY',
                    f10: 'DD-MM-YY',
                    f11: 'DD/MM/YYYY',
                    f12: 'DD-MM-YYYY',
                    f13: 'YYYY-MM-DD',
                },
                time: {
                    f1: 'HH:mm',
                    f2: 'HH:mm:ss',
                    f3: 'hh:mm a',
                    f4: 'hh:mm:ss a',
                    picker: {
                        hhmm: 'hh:mm a',
                        hhmmss: 'hh:mm:ss a',
                    },
                    type: 12,
                },
            },
            numbers: {
                separators: {
                    decimals: ',',
                    thousands: '.',
                },
            },
        },
        esAR: {
            code: 'es-AR',
            id: 'es',
            format: {
                date: {
                    f1: 'd/m/y',
                    f2: 'd-m-y',
                    f3: 'dd/mm/yy',
                    f4: 'dd-mm-yy',
                    f5: 'dd/mm/yyyy',
                    f6: 'dd-mm-yyyy',
                    f7: 'D/M/Y',
                    f8: 'D-M-Y',
                    f9: 'DD/MM/YY',
                    f10: 'DD-MM-YY',
                    f11: 'DD/MM/YYYY',
                    f12: 'DD-MM-YYYY',
                    f13: 'YYYY-MM-DD',
                },
                time: {
                    f1: 'HH:mm',
                    f2: 'HH:mm:ss',
                    f3: 'hh:mm a',
                    f4: 'hh:mm:ss a',
                    picker: {
                        hhmm: 'hh:mm a',
                        hhmmss: 'hh:mm:ss a',
                    },
                    type: 12,
                },
            },
            numbers: {
                separators: {
                    decimals: ',',
                    thousands: '.',
                },
            },
        },
        esCL: {
            code: 'es-CL',
            id: 'es',
            format: {
                date: {
                    f1: 'd/m/y',
                    f2: 'd-m-y',
                    f3: 'dd/mm/yy',
                    f4: 'dd-mm-yy',
                    f5: 'dd/mm/yyyy',
                    f6: 'dd-mm-yyyy',
                    f7: 'D/M/Y',
                    f8: 'D-M-Y',
                    f9: 'DD/MM/YY',
                    f10: 'DD-MM-YY',
                    f11: 'DD/MM/YYYY',
                    f12: 'DD-MM-YYYY',
                    f13: 'YYYY-MM-DD',
                },
                time: {
                    f1: 'HH:mm',
                    f2: 'HH:mm:ss',
                    f3: 'hh:mm a',
                    f4: 'hh:mm:ss a',
                    picker: {
                        hhmm: 'hh:mm a',
                        hhmmss: 'hh:mm:ss a',
                    },
                    type: 12,
                },
            },
            numbers: {
                separators: {
                    decimals: ',',
                    thousands: '.',
                },
            },
        },
        esCO: {
            code: 'es-CO',
            id: 'es',
            format: {
                date: {
                    f1: 'd/m/y',
                    f2: 'd-m-y',
                    f3: 'dd/mm/yy',
                    f4: 'dd-mm-yy',
                    f5: 'dd/mm/yyyy',
                    f6: 'dd-mm-yyyy',
                    f7: 'D/M/Y',
                    f8: 'D-M-Y',
                    f9: 'DD/MM/YY',
                    f10: 'DD-MM-YY',
                    f11: 'DD/MM/YYYY',
                    f12: 'DD-MM-YYYY',
                    f13: 'YYYY-MM-DD',
                },
                time: {
                    f1: 'HH:mm',
                    f2: 'HH:mm:ss',
                    f3: 'hh:mm a',
                    f4: 'hh:mm:ss a',
                    picker: {
                        hhmm: 'hh:mm a',
                        hhmmss: 'hh:mm:ss a',
                    },
                    type: 12,
                },
            },
            numbers: {
                separators: {
                    decimals: ',',
                    thousands: '.',
                },
            },
        },
        esMX: {
            code: 'es-MX',
            id: 'es',
            format: {
                date: {
                    f1: 'd/m/y',
                    f2: 'd-m-y',
                    f3: 'dd/mm/yy',
                    f4: 'dd-mm-yy',
                    f5: 'dd/mm/yyyy',
                    f6: 'dd-mm-yyyy',
                    f7: 'D/M/Y',
                    f8: 'D-M-Y',
                    f9: 'DD/MM/YY',
                    f10: 'DD-MM-YY',
                    f11: 'DD/MM/YYYY',
                    f12: 'DD-MM-YYYY',
                    f13: 'YYYY-MM-DD',
                },
                time: {
                    f1: 'HH:mm',
                    f2: 'HH:mm:ss',
                    f3: 'hh:mm a',
                    f4: 'hh:mm:ss a',
                    picker: {
                        hhmm: 'hh:mm a',
                        hhmmss: 'hh:mm:ss a',
                    },
                    type: 12,
                },
            },
            numbers: {
                separators: {
                    decimals: ',',
                    thousands: '.',
                },
            },
        },
        esUS: {
            code: 'es-US',
            id: 'es',
            format: {
                date: {
                    f1: 'd/m/y',
                    f2: 'd-m-y',
                    f3: 'dd/mm/yy',
                    f4: 'dd-mm-yy',
                    f5: 'dd/mm/yyyy',
                    f6: 'dd-mm-yyyy',
                    f7: 'D/M/Y',
                    f8: 'D-M-Y',
                    f9: 'DD/MM/YY',
                    f10: 'DD-MM-YY',
                    f11: 'DD/MM/YYYY',
                    f12: 'DD-MM-YYYY',
                    f13: 'YYYY-MM-DD',
                },
                time: {
                    f1: 'HH:mm',
                    f2: 'HH:mm:ss',
                    f3: 'hh:mm a',
                    f4: 'hh:mm:ss a',
                    picker: {
                        hhmm: 'hh:mm a',
                        hhmmss: 'hh:mm:ss a',
                    },
                    type: 12,
                },
            },
            numbers: {
                separators: {
                    decimals: ',',
                    thousands: '.',
                },
            },
        },
        esVE: {
            code: 'es-VE',
            id: 'es',
            format: {
                date: {
                    f1: 'd/m/y',
                    f2: 'd-m-y',
                    f3: 'dd/mm/yy',
                    f4: 'dd-mm-yy',
                    f5: 'dd/mm/yyyy',
                    f6: 'dd-mm-yyyy',
                    f7: 'D/M/Y',
                    f8: 'D-M-Y',
                    f9: 'DD/MM/YY',
                    f10: 'DD-MM-YY',
                    f11: 'DD/MM/YYYY',
                    f12: 'DD-MM-YYYY',
                    f13: 'YYYY-MM-DD',
                },
                time: {
                    f1: 'HH:mm',
                    f2: 'HH:mm:ss',
                    f3: 'hh:mm a',
                    f4: 'hh:mm:ss a',
                    picker: {
                        hhmm: 'hh:mm a',
                        hhmmss: 'hh:mm:ss a',
                    },
                    type: 12,
                },
            },
            numbers: {
                separators: {
                    decimals: ',',
                    thousands: '.',
                },
            },
        },
        es419: {
            code: 'es-419',
            id: 'es',
            format: {
                date: {
                    f1: 'd/m/y',
                    f2: 'd-m-y',
                    f3: 'dd/mm/yy',
                    f4: 'dd-mm-yy',
                    f5: 'dd/mm/yyyy',
                    f6: 'dd-mm-yyyy',
                    f7: 'D/M/Y',
                    f8: 'D-M-Y',
                    f9: 'DD/MM/YY',
                    f10: 'DD-MM-YY',
                    f11: 'DD/MM/YYYY',
                    f12: 'DD-MM-YYYY',
                    f13: 'YYYY-MM-DD',
                },
                time: {
                    f1: 'HH:mm',
                    f2: 'HH:mm:ss',
                    f3: 'hh:mm a',
                    f4: 'hh:mm:ss a',
                    picker: {
                        hhmm: 'hh:mm a',
                        hhmmss: 'hh:mm:ss a',
                    },
                    type: 12,
                },
            },
            numbers: {
                separators: {
                    decimals: ',',
                    thousands: '.',
                },
            },
        },
    },
    localStorage: {
        userId: REACT_APP_LOCALSTORAGE_ID,
        redirectId: `${REACT_APP_LOCALSTORAGE_ID}_redirectUrl`,
    },
    messages: {
        accessDenied: {
            en: 'Access denied',
            es: 'Acceso denegado',
        },
        addToken: 'Add token please wait..',
        afterDeletingPublicationThereIsNoGoingBack: {
            en: 'After <b>deleting</b> a publication there is no going back',
            es: 'Después de <b>borrar</b> una publicación no hay vuelta atrás',
        },
        allowedCharacters: {
            en: 'Allowed characters',
            es: 'Caracteres permitidos',
        },
        areYouShureDeleteThis: {
            en: 'Are you shure delete this?',
            es: '¿Estás seguro de eliminar esto?',
        },
        areYouSureToLogOut: {
            en: 'Are you sure to logout?',
            es: '¿Estás seguro de cerrar sesión?',
        },
        avaliableQuantityYouMustEnterOnlyNumbersAndDot: '<b>Avaliable quantity</b><br/>You must enter only numbers and a dot',
        availableQuantityBeMustGreaterThanZero: {
            en: '<b>Available quantity</b> be must greater than zero',
            es: '<b>Cantidad disponible</b> debe ser mayor que cero',
        },
        charactersRemaining: {
            en: 'Characters remaining',
            es: 'Caracteres restantes',
        },
        clickToDefineTheLogo: {
            en: 'Click to define the logo',
            es: 'Haga clic para definir el logo',
        },
        clickOnTheImageToDefineTheLogo: {
            en: 'Click on the image to define the logo',
            es: 'Haga clic en la imagen para definir el logo',
        },
        clickToDefineThePicture: {
            en: 'Click to define the picture',
            es: 'Haga clic para definir la imagen',
        },
        clickToDeleteThePicture: {
            en: 'Click to delete the picture',
            es: 'Haga clic para eliminar la imagen',
        },
        clickToRestoreThePicture: {
            en: 'Click to restore the picture',
            es: 'Haga clic para restaurar la imagen',
        },
        closedItemCanOnlyBeActivatedOrDeleted: 'Closed item can only be <b>activated</b> or <b>deleted</b>',
        creatingNewRate: 'Creating new rate, please wait..',
        currentPasswordNotValid: 'Current password is not valid',
        deleteTokenLogs: 'Delete tokens (logs) please wait..',
        deleteUserProcesing: 'Delete user Procesing please wait..',
        displaysTheBuyerName: {
            en: 'Displays the buyer name',
            es: 'Muestra e nombre del comprador',
        },
        displaysTheGreetingAccordingToTheTime: {
            en: 'Displays the greeting according to the time',
            es: 'Muestra el saludo según la hora',
        },
        doYouWantAuthorizeTheUser: 'Do you want to authorize the user',
        doYouWantRemoveTheUserAuthorization: 'Do you want to remove the user authorization',
        doYouWantToChangeTheAuthorizationStatus: {
            en: 'do you want to change the authorization status?',
            es: '¿Desea cambiar el estado de autorización?',
        },
        doYouWantToChangeTheEmailConfirmationStatus: {
            en: 'Do you want to change the email confirmation status?',
            es: '¿Desea cambiar el estado de la confirmación correo electrónico?',
        },
        doYouWantToSendWelcomeEmail: {
            en: 'Do you want to send a welcome email?',
            es: '¿Quieres enviar un email de bienvenida?',
        },
        doYouWantConfirmTheEmail: 'Do you want to confirm the email',
        doYouWantSendTheConfirmationEmail: 'Do you want to send the confirmation email',
        doYouWantGenerateAuthorization: {
            en: 'Do you want to generate authorization?',
            es: '¿Desea generar una autorización?',
        },
        doYouWantToGenerateTheToken: {
            en: 'Do you want to generate the token?',
            es: '¿Desea generar el token?',
        },
        doYouWantUpdateData: {
            en: 'Do you want to update the data?',
            es: '¿Desea actualizar los datos?',
        },
        doYouWantToUpdateCustomers: {
            en: 'Do you want to update customers?',
            es: '¿Desea actualizar los clientes?',
        },
        doYouWantRemoveTheConfirmationFromEmail: 'Do you want to remove the confirmation from the email',
        emojiCopiedToMemory: {
            en: 'Emoji copied to memory',
            es: 'Emoji copiado en memoria',
        },
        forgotPasswordSubTitle01: {
            en: 'You must enter your <b>email</b> to send the password recovery instructions',
            es: 'Debes introducir tu <b>correo</b> para enviar las instrucciones de recuperación de contraseña'
        },
        forgotPasswordSubTitle02: {
            en: 'The email must be previously <b>registered in our system</b>, otherwise no information will be sent',
            es: 'El correo debe estar previamente <b>registrado en nuestro sistema</b>, de lo contrario no se enviará la información',
        },
        freeItemsOnlyAllowOneQuantity: {
            en: 'Free items only allow <b>1</b> quantity',
            es: 'Los artículos gratuitos sólo admiten <b>1</b> cantidad',
        },
        forSecurityReasonsYouMustLogInWithTheNewPassword: {
            en: 'For security reasons you must log in with the new password',
            es: 'Por seguridad deberá iniciar sesión con la nueva contraseña',
        },
        getUsers: 'Get users, please wait..',
        getUser: 'Get user, please wait..',
        getUserData: 'Get user data please wait..',
        getItemData: 'Get item id data, please wait..',
        getItemsId: 'Get items id, please wait..',
        getItemsDetails: 'Get items details, please wait..',
        getUserInformation: 'Get user information, please wait..',
        getRates: 'Get rates, please wait..',
        getTokenData: 'Get token data please wait..',
        getTokenNew: 'Get token (new) please wait..',
        getTokenLogs: 'Get tokens (logs) please wait..',
        getTokenRefresh: 'Get token (refresh) please wait..',
        hasNotBeenCreatedYet: {
            en: 'Has not been created yet',
            es: 'No ha sido creado aún',
        },
        itemUpdatedSuccessfully: {
            en: 'Item updated successfully',
            es: 'Artículo actualizado satisfactoriamente',
        },
        itIsRequired: {
            en: 'It is required',
            es: 'Es requerido',
        },
        //itWillAutomaticallyCalculatePriceAnotherCurrency: 'It will automatically calculate<br/>The <b>price of another currency</b>',
        loginFormParagraph1: {
            en: 'Use a local account to log in. If you do not have an account, still request it here',
            es: 'Utilice una cuenta local para iniciar sesión. Si no tiene una cuenta, solicítela aquí',
        },
        loginFormParagraph2: {
            en: 'If you already made a request you can monitor the status of it here',
            es: 'Si ya realizó una solicitud, puede monitorear el estado de la misma aquí',
        },
        maximunWeightAllowed: {
            en: 'Maximum weight allowed',
            es: 'Peso máximo permitido',
        },
        newPasswordAndNewPasswordConfirmNotMatch: {
            en: 'The <b>new password</b> and <b>new password confirm</b> fields do not match',
            es: 'Los campos <b>nueva contraseña</b> y <b>nueva contraseña confirmada</b> no coinciden',
        },
        noDataFound: {
            en: 'Not data found',
            es: 'Información no encontrada',
        },
        noPublicationsYet: {
            en: 'No publications yet',
            es: 'No hay publicaciones aún',
        },
        numberAllowed: {
            en: 'Number allowed',
            es: 'Cantidad permitida',
        },
        onceFinalizedItCanNotBeEdited: {
            en: 'Once <b>finalized</b> it cannot be edited',
            es: 'Una vez <b>finalizado</b> no puede ser editado',
        },
        onlyImageTypeFilesAreAllowed: {
            en: 'Only <b>image</b> type files are <b>allowed</b>',
            es: 'Solo los archivos de tipo <b>imagen</b> están <b>permitidos</b>',
        },
        onlyMaximumNumberOfFilesIsAllowed: {
            en: 'Only a maximum number of files is allowed',
            es: 'Sólo está permitido un máximo de archivos',
        },
        onlyPlainTextIsAllowed: {
            en: 'Only plain text is allowed',
            es: 'Sólo se permite texto sin formato',
        },
        onlyTheFollowingFilesAreAllowed: {
            en: 'Only the following files are allowed',
            es: 'Soló se permiten los siguientes archivos',
        },
        pageNotFound: {
            en: 'Page not found',
            es: 'Página no encontrada'
        },
        passwordMinimunCharacters: {
            en: `Minimun <b>${settingsPassword.maxLength}</b> characters`,
            es: `Mínimo <b>${settingsPassword.maxLength}</b> caracteres`,
        },
        passwordAndPasswordConfirmNotMatch: {
            en: 'The <b>Password</b> and <b>Password Confirm</b> fields do not match',
            es: 'La <b>contraseña</b> y la <b>confirmación de contraseña</b> no son iguales'
        },
        pleaseAcceptTheCaptcha: {
            en: 'Please accept the captcha',
            es: 'Por favor acepta el captcha',
        },
        pleaseTryAgain: {
            en: 'Please try again',
            es: 'Por favor vuelva a intentar',
        },
        processingPleaseWait: {
            en: 'Processing, please wait..',
            es: 'Procesando, por favor espere..',
        },
        processCompletedSuccessfully: {
            en: 'Process completed successfully',
            es: 'Proceso finalizado satisfactoriamente',
        },
        priceOtherCurrencyYouMustEnterOnlyNumbersAndDot: {
            en: '<b>Price other currency</b> you must enter only numbers and a dot',
            es: '<b>Precio en otra moneda</b> debe ingresar solo números y un punto'
        },
        priceOtherCurrencyBeMustGreaterThanOrEqualToZero: {
            en: '<b>Price other currency</b> be must greater than or equal to zero',
            es: '<b>Precio en otra moneda</b> debe ser mayor o igual a cero',
        },
        recoverPasswordForm: {
            paragraph1: {
                en: 'You must enter your <b>email</b> to send the password recovery instructions',
                es: 'Debes ingresar tu <b>correo</b> electrónico para enviar las instrucciones de recuperación de contraseña',
            },
            paragraph2: {
                en: 'The email must be previously <b>registered in our system</b>, otherwise no information will be sent',
                es: 'El correo electrónico debe estar previamente <b>registrado en nuestro sistema</b>, de lo contrario no se enviará información.',
            }
        },
        rememberToEnableTheBotAndAddMessageAccordingToItsFunction: {
            en: 'Remember to enable the robot and add message according to its function',
            es: 'Recuerda habilitar el robot y agregar mensaje según su función',
        },
        registerNewUserTittle01: 'Perfect, you just need to verify your account',
        rateCreatedSuccessfully: {
            en: 'Rate created successfully',
            es: 'Tasa creada satisfactoriamente',
        },
        requestAccountParagraph1: {
            en: 'You will formally request <b>access credentials to our system</b>, please submit the following considerations so that the approval is <b>satisfactory</b>',
            es: 'Solicitará formalmente las credenciales de <b>acceso a nuestro sistema</b>, por favor presente las siguientes consideraciones para que la aprobación sea <b>satisfactoria</b>',
        },
        requestAccountParagraph2: {
            en: 'That you are <b>currently an employee</b> of the company to which access is requested',
            es: 'Que usted sea <b>empleado actualmente</b> de la empresa a la que se solicita el acceso',
        },
        requestAccountParagraph3: {
            en: 'That some personnel within the company (<b>Human management / Presidency / Management</b>) can validate that you are an active employee',
            es: 'Que algún personal dentro de la empresa (<b>Recursos humanos / Presidencia / Gerencia</b>) pueda validar que eres un empleado activo',
        },
        requestAccountParagraph4: {
            en: 'That your information is <b>correct</b> and you have access to the email you <b>provide</b>',
            es: 'Que tus datos sean <b>correctos</b> y tengas acceso al correo que <b>proporcionas</b>',
        },
        requestAccountDetails: {
            isNew: {
                paragraph1: {
                    en: 'A <b>credential request</b> has been created with the data that <b>you have provided</b>. Please note that for your <b>approval</b> we will have to contact the company that you have indicated to confirm that <b>you are an employee of it</b>',
                    es: 'Se ha creado una <b>solicitud de credencial</b> con los datos que <b>usted ha proporcionado</b>. Tenga en cuenta que para su <b>aprobación</b> tendremos que contactar con la empresa que nos ha indicado para confirmar que <b>es empleado de la misma</b>',
                },
            },
            isNotNew: {
                paragraph1: {
                    en: 'A <b>request already</b> exists with the following data. Please note that for your <b>approval</b> we will have to contact the company that you have indicated to confirm that <b>you are an employee of it</b>',
                    es: 'Ya existe una solicitud con los siguientes datos. Tenga en cuenta que para su aprobación tendremos que contactar con la empresa que nos ha indicado para confirmar que es empleado de la misma',
                },
            },
            paragraph2: {
                en: 'If we cannot validate <b>your information</b> with the company',
                es: 'Si no podemos validar <b>su información</b> con la empresa',
            },
            paragraph3: {
                en: 'If any <b>data</b> does not correspond to the <b>information of your company</b>',
                es: 'Si algún <b>dato</b> no se corresponde con la <b>información de su empresa</b>',
            },
            paragraph4: {
                en: 'If the company <b>cannot validate<b> that you work there or <b>is an employee (direct or indirect) of them</b>',
                es: 'Si la empresa <b>no puede validar</b> que trabajas allí o <b>eres empleado (directo o indirecto) de ellos</b>',
            },
            paragraph5: {
                en: 'If any of the aforementioned characteristics <b>does not comply with the requirements at the time of validating the information with the company</b>, then the request will be <b>immediately canceled</b>',
                es: 'Si alguna de las características antes mencionadas <b>no cumple con los requisitos al momento de validar la información con la empresa</b>, entonces la solicitud será <b>cancelada inmediatamente</b>',
            },
        },
        selectAnalyst: {
            en: 'Select an analyst',
            es: 'Selecciona un analista',
        },
        selectCompany: {
            en: 'Select a company',
            es: 'Selecciona una empresa',
        },
        selectCountry: {
            en: 'Select a country',
            es: 'Selecciona un país',
        },
        selectCustomer: {
            en: 'Select a customer',
            es: 'Selecciona un cliente',
        },
        selectDateRange: {
            en: 'Select date range',
            es: 'Selecciona rango de fecha',
        },
        selectDevice: {
            en: 'Select a device',
            es: 'Selecciona un dispositivo',
        },
        selectEvent: {
            en: 'Select an event',
            es: 'Selecciona un evento',
        },
        selectMethod: {
            en: 'Select a method',
            es: 'Selecciona un método',
        },
        selectRole: {
            en: 'Select a role',
            es: 'Selecciona un rol',
        },
        selectStatus: {
            en: 'Select a status',
            es: 'Selecciona un estatus',
        },
        selectType: {
            en: 'Select a type',
            es: 'Selecciona un tipo',
        },
        selectUser: {
            en: 'Select a user',
            es: 'Selecciona un usuario',
        },
        systemAdministratorMustApproveYourAccount: 'A system <b>administrator</b> must approve your <b>account</b>',
        systemAdministratorMustAssignYouRole: 'A system <b>administrator</b> must assign you a <b>role</b>',
        synchronizingData: 'Synchronizing data, please wait..',
        textWithInvalidHtmlFormatting: {
            en: 'Text with invalid html formatting',
            es: 'Texto con formato html inválido',
        },
        theEmailAlreadyByAnotherAccount: 'The <b>email</b> address is <b>already</b> in use by another account',
        theItemIsInStatusUnderReviewYouMustCorrectTheProblemInTheMercadoLibrePortal: {
            en: 'The item is in status: <b>under review</b>, you must correct the problem in the <b>Mercado Libre</b> portal',
            es: 'El artículo se encuentra en estado: <b>en revisión</b>, debe corregir el problema en el portal de <b>Mercado Libre</b>',
        },
        thereIsNoDataToProcess: {
            en: 'There is no data to process',
            es: 'No hay datos que procesar',
        },
        thereAreNotRecordsDelete: 'There are not records to delete',
        theInstructionsPasswordRecoveryWereSentEmail: 'The instructions for the <b>password recovery</b> were sent to your email',
        //thePasswordHasBeenUpdatedSuccessfully: 'The data has been updated successfully',
        thePasswordHasBeenChangedSuccessfully: {
            en: 'The password has been changed successfully',
            es: 'La contraseña se ha modificado satisfactoriamente',
        },
        theRateMustBeGreaterThanZero: 'The rate must be greater than zero',
        theRecordCannotBeLocated: {
            en: 'The record cannot be located',
            es: 'El registro no puede ser localizado',
        },
        thisProcessIrreversibleDoYouWishContinue: {
            en: 'This process is irreversible.<br/>Do you wish to continue?',
            es: 'Este proceso es irreversible<br/>¿Desea continuar?',
        },
        thisUserDoesNotExist: 'This user does not exist',
        thisFieldRequired: {
            en: 'This <b>field</b> is <b>required</b>',
            es: 'Este <b>campo</b> es requerido',
        },
        thisModuleDoesNotAllowMoreThanOneRecord: {
            en: 'This module does not allow more than one record',
            es: 'Este módulo no permite más de un registro',
        },
        toDoThisYouMustEditTheInformation: {
            en: 'To do this you must edit the information',
            es: 'Para eso debe editar la información',
        },
        tokenCreatedSuccessfully: 'Token created successfully',
        tokenGeneratedSuccessfully: 'Token generated successfully',
        tokenHasExpired: 'The token has expired',
        tokenIsTillValid: 'The token is till valid',
        userEdited: 'User edited sucessfully',
        updateUser: 'Update user please wait..',
        userCreateSucessfully: 'User create sucessfully',
        userDeletedSucessfully: 'User detelted sucessfully',
        updatingItem: 'Updating item, please wait..',
        userUpdatedSuccessfully: 'User updated successfully',
        userMustHaveCodeBeforeGeneratingToken: {
            en: 'User must have code before generating token',
            es: 'El usuario debe tener el código antes de generar el token',
        },
        updateUserInformation: 'Update user information, please wait..',
        youCanNowLogInWithTheNewPassword: {
            en: 'You can now log in with the new password',
            es: 'Ahora puede iniciar sesión con la nueva contraseña',
        },
        youDoNotHaveSufficientPrivilegesToRunThisProcess: {
            en: 'You do not have sufficient privileges to run this process',
            es: 'No tiene suficientes privilegios para ejecutar este proceso',
        },
        youMustGreaterThanOrEqualToZero: {
            en: 'You must greater than or equal to zero',
            es: 'Debe ser mayor o igual que cero',
        },
        youMustLogInAccessThisSection: {
            en: 'You must <b>log in</b> to access this <b>section</b>',
            es: 'Debes estar <b>autenticado</b> para acceder a esta <b>sección</b>',
        },
        youMustConfirmYourEmailAccountCompleteRegistration: {
            en: 'You must confirm your email account to complete the registration',
            es: 'Debe confirmar su cuenta de correo electrónico para completar el registro',
        },
        youMustDefineFileTypes: {
            en: 'You must define file types',
            es: 'Debes definir tipo de archivos',
        },
        youMustEnterValidDate: {
            en: 'You must enter valid <b>date</b>',
            es: 'Debe ingresar una <b>fecha</b> válida',
        },
        youMustEnterValidEmail: {
            en: 'You must enter valid <b>email</b>',
            es: 'Debe ingresar un <b>correo</b> válido',
        },
        youMustEnterValidTelegramId: {
            en: 'You must enter a valid <b>Telegram id</b>',
            es: 'debe introducir un <b>id</b> de <b>Telegram</b> válida',
        },
        youMustEnterOnlyNumbersAndDot: {
            en: 'You must enter only numbers and a dot',
            es: 'Debes ingresar solo números y un punto',
        },
        youMustChooseWhoToApplyTo: 'You must choose who to apply to',
        youMustEnterAnUserNameValid: 'You must enter an user name valid',
        youMustEnterValidPassword: {
            en: 'You must enter a valid <b>password</b>',
            es: 'Debes ingresar una <b>contraseña</b> válida',
        },
        youMustEnterValidNewPassword: {
            en: 'You must enter a valid <b>new password</b>',
            es: 'Debes ingresar una <b>contraseña nueva</b> válida',
        },
        youMustEnterValidPasswordConfirm: {
            en: 'You must enter a valid <b>password confirm</b>',
            es: 'Debes ingresar una <b>confirmación de contraseña</b> válida'
        },
        youMustEnterValidNewPasswordConfirm: {
            en: 'You must enter a valid <b>new password confirm</b>',
            es: 'Debes ingresar una <b>confirmacion de contraseña</b> válida',
        },
        youMustEnterValidPhoneNumber: {
            en: 'You must enter a valid <b>phone number</b>',
            es: 'Debes ingresar un <b>número de teléfono</b> válido',
        },
        youMustEnterValidUrl: {
            en: 'You must enter a valid <b>url</b>',
            es: 'Debes ingresar una <b>url</b> válida',
        },
        youMustEnterValidAmount: 'You must enter a valid amount',
        youMustEnterValidDateTimeValue: 'You must enter a valid date time',
        youMustEnterValidTitle: 'You must enter a valid title',
        yourPasswordHasBeenChanged: {
            en: 'Your password has been changed',
            es: 'Su contraseña ha sido cambiada',
        },
        waitingConfirmation: 'Waiting confirmation',
        weCouldNotFindThePageYouWereLookingFor: {
            en: 'We could not find the page you were looking for',
            es: 'No podemos encontrar la página que estas buscando',
        },
    },
    nativeObjs: {
        string: 'string',
        object: 'object',
    },
    numberPositions: {
        decimalPlaces: 2,
    },
    objects: {
        html: {
            notifications: {
                toast: {
                    btnGlobal: 'btnToast',
                    textArea: {
                        id: 'notificationsToastId'
                    },
                },
                toastHide: {
                    textArea: {
                        id: 'notificationsToastHideId'
                    },
                },
                toastHideInnerText: {
                    textArea: {
                        id: 'notificationsToastHideInnerTextId'
                    },
                },
            },
        },
    },
    passwords: {
        maxLength: 12,
        minLength: 6,
    },
    react: {
        CssfxLoading: {
            barWave: 'BarWave',
            bouncingBalls: 'BouncingBalls',
            coin: 'Coin',
            circularProgress: 'CircularProgress',
            fadingBalls: 'FadingBalls',
            fadingDots: 'FadingDots',
            fillingBottle: 'FillingBottle',
            flippingSquare: 'FlippingSquare',
            hypnosis: 'Hypnosis',
            messaging: 'Messaging',
            ring: 'Ring',
            spin: 'Spin',
            spinStretch: 'SpinStretch',
            twinSpin: 'TwinSpin',
        },
        dropZone: {
            imagesAccepted: {
                'image/png': [],
                'image/jpeg': [],
                'image/jpg': [],
                'image/bmp': [],
            },
        },
        html: {
            button: {
                classes: {
                    disabled: 'btn disabled',
                    progress: 'btn-progress',
                },
            },
            dropDown: {
                active: 'dropdown active',
                normal: 'dropdown',
            },
            li: {
                active: 'active text-primary',
                normal: '',
            },
            spaces: {
                one: '&nbsp;',
                two: '&nbsp;&nbsp;',
                three: '&nbsp;&nbsp;&nbsp;',
            },
            spinner: {
                borderSm: 'spinner-border spinner-border-sm',
            }
        },
        reCAPTCHA: {
            //reCAPTCHASiteKey: REACT_APP_RECAPTCHA_SITE_KEY,
            reCAPTCHASiteKey: REACT_APP_RECAPTCHAv3_SITE_KEY,
            //reCaptchaV2SiteKey: REACT_APP_RECAPTCHAv2_SITE_KEY,
            reCaptchaV2SiteKey: REACT_APP_RECAPTCHAv2_SITE_KEY,
            urlPrivaciConditions: 'https://policies.google.com/terms?hl=es-419',
        },
        sweetAlert2: {
            dismiss: {
                backdrop: 'backdrop',
                cancel: 'cancel',
            },
            messages: {
                types: {
                    error: 'error',
                    success: 'success',
                    warning: 'warning',
                    info: 'info',
                    question: 'question',
                },
            },
            position: {
                top: 'top',
                topStart: 'top-start',
                topEnd: 'top-end',
                topLeft: 'top-left',
                topRight: 'top-right',
                center: 'center',
                centerStart: 'center-start',
                centerEnd: 'center-end',
                centerLeft: 'center-left',
                centerRight: 'center-right',
                bottom: 'bottom',
                bottomStart: 'bottom-start',
                bottomEnd: 'bottom-end',
                bottomLeft: 'bottom-left',
                bottomRight: 'bottom-right',
            },
        },
        tempusDominus: {
            buttons: {
                showToday: true,
                showClear: false,
                showClose: true,
            },
            icons: {
                time: 'fas fa-clock',
                date: 'fas fa-calendar',
                up: 'fas fa-arrow-up',
                down: 'fas fa-arrow-down',
                previous: 'fas fa-chevron-left',
                next: 'fas fa-chevron-right',
                today: 'fas fa-calendar-check-o',
                clear: 'fas fa-trash',
                close: 'fas fa-times'
            },
            tooltips: ({
                languageId = 'en'
            } = {}) => {
                switch (languageId) {
                    case 'es':
                        return {
                            today: 'Hoy',
                            clear: 'Inicializar selección',
                            close: 'Cerrar selector',
                            selectMonth: 'Seleccionar mes',
                            prevMonth: 'Mes anterior',
                            nextMonth: 'Próximo mes',
                            selectYear: 'Seleccionar año',
                            prevYear: 'Año anterior',
                            nextYear: 'Año siguiente',
                            selectDecade: 'Selecciondar decada',
                            prevDecade: 'Década anterior',
                            nextDecade: 'Década siguiente',
                            prevCentury: 'Siglo anterior',
                            nextCentury: 'Siglo siguiente',
                            pickHour: 'Seleccionar hora',
                            incrementHour: 'Incrementar hora',
                            decrementHour: 'Disminuir hora',
                            pickMinute: 'Seleccionar minuto',
                            incrementMinute: 'Incrementar minuto',
                            decrementMinute: 'Disminuir minuto',
                            pickSecond: 'Seleccionar segundo',
                            incrementSecond: 'Incrementar segundo',
                            decrementSecond: 'Disminuir segundo',
                            togglePeriod: 'Alternar período',
                            selectTime: 'Seleccionar hora',
                            selectDate: 'Seleccionar fecha',
                        };
                    default:
                        return {
                            today: 'Today',
                            clear: 'Clear',
                            close: 'Close',
                            selectMonth: 'Select month',
                            prevMonth: 'Prev. month',
                            nextMonth: 'Next month',
                            selectYear: 'Select year',
                            prevYear: 'Prev. year',
                            nextYear: 'Next year',
                            selectDecade: 'Select decade',
                            prevDecade: 'Prev. decade',
                            nextDecade: 'Next decade',
                            prevCentury: 'Prev. century',
                            nextCentury: 'Next century',
                            pickHour: 'Select hour',
                            incrementHour: 'Increment hour',
                            decrementHour: 'Decrement hour',
                            pickMinute: 'Pick minute',
                            incrementMinute: 'Increment minute',
                            decrementMinute: 'Decrement minute',
                            pickSecond: 'Pick second',
                            incrementSecond: 'Increment second',
                            decrementSecond: 'Decrement second',
                            togglePeriod: 'Toggle period',
                            selectTime: 'Select time',
                            selectDate: 'Select date',
                        };
                }
            },
            formats: {
                date: {
                    dmy: 'd/m/y',
                    dmyTwo: 'd-m-y',
                    mdy: 'm/d/y',
                    mdyTwo: 'm-d-y',
                    ymd: 'y/m/d',
                    ymdTwo: 'y-m-d',
                    DMY: 'D/M/Y',
                    DDMMYY: 'DD/MM/YY',
                    DDMMYYYY: 'DD/MM/YYYY',
                    DDMMYYYYTwo: 'DD-MM-YYYY',
                    MMDDYYYY: 'MM/DD/YYYY',
                    MMDDYYYYTwo: 'MM-DD-YYYY',
                    YYYYMMDD: 'YYYY/MM/DD',
                    YYYYMMDDTwo: 'YYYY-MM-DD',
                },
                time: {
                    hhmmA: 'hh:mm A',
                    hhmma: 'hh:mm a',
                    hhmmssA: 'hh:mm:ss A',
                    hhmmssa: 'hh:mm a',
                    HHmm: 'HH:mm',
                    HHmmss: 'HH:mm:ss',
                },
            },
            //#region old code
            //formats.date.dmy: 'd/m/y',
            //formats.date.dmyTwo: 'd-m-y',
            //formats.date.mdy: 'm/d/y',
            //formats.date.mdyTwo: 'm-d-y',
            //formats.date.ymd: 'y/m/d',
            //formats.date.ymdTwo: 'y-m-d',
            //formats.date.DMY: 'D/M/Y',
            //formats.date.DDMMYY: 'DD/MM/YY',
            //formats.date.DDMMYYYY: 'DD/MM/YYYY',
            //formats.date.DDMMYYYYTwo: 'DD-MM-YYYY',
            //formats.date.MMDDYYYY: 'MM/DD/YYYY',
            //formats.date.MMDDYYYYTwo: 'MM-DD-YYYY',
            //formats.date.YYYYMMDD: 'YYYY/MM/DD',
            //formats.date.YYYYMMDDTwo: 'YYYY-MM-DD',
            //formats.time.hhmmA: 'hh:mm A',
            //formats.time.HHmm: 'HH:mm',
            //#endregion old code
            values: {
                //begin01: '0000-00-00 00:00:00.0000000',
                begin01: '1900-01-01 00:00:00.0000000',
            },
        },
    },
    roles: {
        admin: 'admin',
        analyst: 'analyst',
        anonymous: 'anonymous',
        service: 'service',
        user: 'user',
        userAdmin: 'userAdmin',
    },
    summerNote: {
        events: {
            code: 'code',
            destroy: 'destroy',
            disable: 'disable',
            enable: 'enable',
            isEmpty: 'isEmpty',
            reset: 'reset',
        },
        btnEvents: {
            code: 'btnSNCode',
            destroy: 'btnSNDestroy',
            disable: 'btnSNDisable',
            enable: 'btnSNEnable',
            init: 'btnSNInit',
            isEmpty: 'btnSNIsEmpty',
            reset: 'btnSNReset',
            setCode: 'btnSNSetCode',
        },
    },
    supplier: {
        name: 'CHEJ Consultor, C.A.',
        slogan: '- Su Requerimiento es Nuestro Compromiso -',
        address: 'Caracas. Miranda - VzLa',
        zipCode: '1060',
        url: 'https://www.chejconsultor.com.ve/',
        phoneNumber001: ' +58 424-2703231',
        phoneNumber002: '+58 412-5958947',
        supportEmail: 'soporte@chejconsultor.com.ve',
        salesEmail: 'sales@chejconsultor.com.ve',
        administrationEmail: 'admon@chejconsultor.com.ve',
        contact: {
            socialNetworks: {
                facebook: 'https://www.facebook.com/CHEJ.Consultor.CA',
                instagram: 'https://www.instagram.com/chejconsultor/',
                telegram: 'https://t.me/CHEJConsultor',
                twitter: 'https://twitter.com/chejconsultor',
                whatsApp: 'https://api.whatsapp.com/send?phone=584242703231&text=Hello%20%F0%9F%91%8B%2C%20I%20want%20to%20get%20in%20touch%20with%20you',
            }
        },
    },
    timers: {
        twoNanoSeconds: 200,
        threeNanoSeconds: 300,
        fourNanoSeconds: 400,
        fiveNanoSeconds: 500,
        oneSecond: 1000,
        twoSeconds: 2000,
        threeSeconds: 3000,
        fourSeconds: 4000,
        fiveSeconds: 5000,
        twentySeconds: 20000,
        thirtySeconds: 30000,
        fourthySeconds: 40000,
        fiftySeconds: 50000,
        sixtySeconds: 60000,
    },
    toast: {
        classes: {
            danger: 'bg-danger',
            info: 'bg-info',
            maroon: 'bg-maroon',
            success: 'bg-success',
            warning: 'bg-warning',
        },
        positions: {
            bottomRight: 'bottomRight',
            bottomLeft: 'bottomRight',
            topRight: 'topRight',
            topLeft: 'topLeft'
        },
    },
    types: [
        {
            name: 'error',
            id: -1,
        },
        {
            name: 'success',
            id: 0,
        },
        {
            name: 'warning',
            id: 1,
        },
        {
            name: 'information',
            id: 2,
        },
        {
            name: 'question',
            id: 3,
        },
        {
            name: 'default',
            id: 4,
        },
    ],
    users: {
        admins: {
            admin01: {
                firstName: 'System',
                lastName: 'Admin - 01',
                email: REACT_APP_ADMIN_EMAIL,
                department: 'System',
                position: 'Admin',
                phoneNumber: '+58 000 0000000',
            },
        },
    },
})

export const getNoImage = ({
    processType = 0,
    subMethod = '',
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'getNoImage';
    try {
        switch (processType) {
            case 0:
                response.result = `${settings?.images?.noImage}`;
                break;
            case 1:
                response.result = `${settings?.backend?.urls?.api}${settings?.backend?.urls?.images}/noImage.png`;
                break;
            default:
                response.result = `${settings?.images?.noImage}`;
                break;
        }
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}<br/>`;
        console?.error(response);
        response.result = false;
    }
    return response;
}

export const navSetting = Object.freeze({
    navItemMenuOpen: 'nav-item menu-open',
    navItem: 'nav-item',
    navLinkActive: 'nav-link active',
    navLink: 'nav-link',
})

export const isUndNullEmp = ({
    data = undefined,
    subMethod = '',
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'isUndNullEmp';
    try {
        response.result = (data === undefined || data === null || data === '' ||
            (Object.keys(data).length <= 0 && data.constructor === Object)
            || (Array.isArray(data) && data?.length <= 0));
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (subMethod !== undefined && subMethod !== null && subMethod !== '') {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}<br/>`;
        console?.error(response);
    }
    return response;
}

export const isUndNull = ({
    data = undefined,
    subMethod = '',
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'isUndNull';
    try {
        response.result = (data === undefined || data === null);
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}<br/>`;
        console?.error(response);
    }
    return response;
}

//#region old code
// export const lodash = {
//     //#region hasIn
//     hasIn: ({
//         obj = {},
//         data = '',
//         subMethod = ''
//     } = {}) => {
//         let response = getResponse({ type: 0 });
//         const currentMethod = 'lodash / hasIn';
//         try {
//             response.result = obj.hasOwnProperty(data);
//         } catch (ex) {
//             response.getResponse({ type: -1, });
//             response.msgText = `Method: ${currentMethod}<br/>`;
//             if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
//                 response.msgText += `Sub method: ${subMethod}<br/>`;
//             }
//             response.msgText += `Error: ${ex?.message}<br/>`;
//             console?.error(response);
//         }
//         return response;
//     },
//     //#endregion hasIn

//     //#region unique
//     unique: ({
//         data = [],
//         key = '',
//         subMethod = ''
//     } = {}) => {
//         let response = getResponse({ type: 0 });
//         const currentMethod = 'lodash / unique';
//         try {
//             if (!isUndNullEmp({ data: key, subMethod: currentMethod })?.result) {
//                 response.result = data.filter((value, index) => data.findIndex((fi) => value[key] === fi[key]) === index);
//             } else {
//                 response.result = data.filter((value, index, array) => array?.indexOf(value) === index);
//             }

//             //#region Examples

//             // let localArray = [
//             //     { 'name': 'Joe', 'age': 17 },
//             //     { 'name': 'Bob', 'age': 17 },
//             //     { 'name': 'Carl', 'age': 35 }
//             // ]
//             // let localUniques = localArray.filter((value, index) => localArray.findIndex((fi) => value.age === fi.age) === index)
//             // console.log(localUniques); // [{'name':'Joe', 'age':17}, {'name':'Carl', 'age': 35}]

//             // localArray = ['a', 1, 'a', 2, '1'];
//             // localUniques = localArray.filter((value, index, array) => array?.indexOf(value) === index);
//             // console.log(localUniques); //['a', 1, 2, '1']

//             //#endregion Examples
//         } catch (ex) {
//             response = getResponse({ type: -1 });
//             response.msgText = `Method: ${currentMethod}<br/>`;
//             if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
//                 response.msgText += `Sub method: ${subMethod}<br/>`
//             }
//             response.msgText += `Error: ${ex?.message}<br/>`;
//             response.result = [];
//         }
//         return response;
//     },
//     //#endregion unique
// }
//#endregion old code

export const lodash = {
    //#region hasin
    hasIn: ({
        obj = {},
        data = '',
        subMethod = ''
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'lodash / hasIn';
        try {
            response.result = obj.hasOwnProperty(data);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    },
    //#endregion hasin

    //#region unique
    unique: ({
        data = [],
        key = '',
        subMethod = ''
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'lodash / unique';
        try {
            if (!isUndNullEmp({ data: key, subMethod: currentMethod })?.result) {
                response.result = data.filter((value, index) => data.findIndex((fi) => value[key] === fi[key]) === index);
            } else {
                response.result = data.filter((value, index, array) => array?.indexOf(value) === index);
            }

            //#region examples

            // let localArray = [
            //     { 'name': 'Joe', 'age': 17 },
            //     { 'name': 'Bob', 'age': 17 },
            //     { 'name': 'Carl', 'age': 35 }
            // ]
            // let localUniques = localArray.filter((value, index) => localArray.findIndex((fi) => value.age === fi.age) === index)
            // console.log(localUniques); // [{'name':'Joe', 'age':17}, {'name':'Carl', 'age': 35}]

            // localArray = ['a', 1, 'a', 2, '1'];
            // localUniques = localArray.filter((value, index, array) => array?.indexOf(value) === index);
            // console.log(localUniques); //['a', 1, 2, '1']

            //#endregion examples
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            response.result = [];
        }
        return response;
    },
    //#endregion unique

    //#region sum
    sum: ({
        data = [],
        key = '',
        consoleLogErrorShow = false,
        subMethod = ''
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'lodash / sum';
        try {
            response.result = data?.reduce((acumulator, object) => {
                return acumulator + object[key];
            }, 0);
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            response.result = [];
            if (consoleLogErrorShow) {
                console?.error(response);
            }
        }
        return response;
    },
    //#endregion sum
}

export const axios = {
    //#region delete

    delete: async ({
        url = '',
        headers = {},
        data = {},
        subMethod = ''
    } = {}) => {
        //#region variables
        let response = getResponse({ type: 0 });
        const currentMethod = 'axios / delete';
        let result = {};

        //#endregion variables
        try {
            //#region variables

            result = {};
            let options = {};

            //#region response is warning

            let responseIsWarning = getResponse({ type: 1, });
            responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                responseIsWarning.msgText += `Sub method: ${subMethod}<br/>`;
            }

            //#endregion response is warning

            //#endregion variables

            //#region method

            options = {
                method: 'DELETE',
                headers: isUndNullEmp({ data: headers, subMethod: currentMethod })?.result ?
                    { 'Content-Type': 'application/json', } :
                    { ...headers, 'Content-Type': 'application/json', },
                body: JSON.stringify(data),
            };

            result = await fetch(url, options,);
            response.result = await result.json();

            switch (result.status) {
                case 200:
                    if (!isUndNullEmp({ data: response?.result, subMethod: currentMethod })?.result &&
                        !isUndNull({ data: response?.result.isSuccess, subMethod: currentMethod })?.result &&
                        !isUndNull({ data: response?.result.isWarning, subMethod: currentMethod })?.result) {
                        response = response?.result;
                    }
                    break;
                default:
                    responseIsWarning.msgText += `Error: ${result.status} - ${result.statusText}<br/>`;
                    //responseIsWarning.msgText += `Code: ${result.status}<br/>`;
                    responseIsWarning.msgText += `Url: ${result.url}<br/>`;
                    responseIsWarning.msgText += `Data (result): ${JSON.stringify(result, null, 4)}<br/>`;
                    responseIsWarning.msgText += `Data: (response / result)${JSON.stringify(response?.result, null, 4)}`;
                    responseIsWarning.result = result;
                    return responseIsWarning;
            }

            //#endregion method
        } catch (ex) {
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }

            switch (isUndNullEmp(result, currentMethod)?.result) {
                case true:
                    response = getResponse({ type: 1 });
                    response.msgText += `Error: 404 - url not found<br/>`;
                    response.msgText += `Message: ${ex?.message}<br/>`;
                    response.msgText += `Url: ${url}<br/>`;
                    response.msgText += `Data: ${JSON.stringify(result, null, 4)}`;
                    break;
                //return response;
                default:
                    response = getResponse({ type: -1 });
                    response.msgText += `Error: ${ex?.message}<br/>`;
                    response.msgText += `Url: ${url}<br/>`;
                    response.msgText += `Data: ${JSON.stringify(result, null, 4)}`;
                    break;
                //return response;
            }
        }
        return response;
    },

    //#endregion delete

    //#region get

    get: async ({
        url = '',
        headers = {},
        subMethod = ''
    } = {}) => {
        //#region variables
        let response = getResponse({ type: 0 });
        const currentMethod = 'axios / get';
        let result = {};

        //#endregion variables
        try {
            //#region variables

            result = {};
            let options = {};

            //#region response is warning

            let responseIsWarning = getResponse({ type: 1, });
            responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                responseIsWarning.msgText += `Sub method: ${subMethod}<br/>`;
            }

            //#endregion response is warning

            //#endregion variables

            //#region method

            options = {
                method: 'GET',
                headers: isUndNullEmp({ data: headers, subMethod: currentMethod })?.result ?
                    { 'Content-Type': 'application/json', } :
                    { ...headers, 'Content-Type': 'application/json', },
            };

            result = await fetch(url, options,);
            response.result = await result.json();

            switch (result.status) {
                case 200:
                    if (!isUndNullEmp({ data: response?.result, subMethod: currentMethod })?.result &&
                        !isUndNull({ data: response?.result.isSuccess, subMethod: currentMethod })?.result &&
                        !isUndNull({ data: response?.result.isWarning, subMethod: currentMethod })?.result) {
                        response = response?.result;
                    }
                    break;
                default:
                    responseIsWarning.msgText += `Error: ${result.status} - ${result.statusText}<br/>`;
                    //responseIsWarning.msgText += `Code: ${result.status}<br/>`;
                    responseIsWarning.msgText += `Url: ${result.url}<br/>`;
                    responseIsWarning.msgText += `Data (result): ${JSON.stringify(result, null, 4)}<br/>`;
                    responseIsWarning.msgText += `Data: (response / result)${JSON.stringify(response?.result, null, 4)}`;
                    responseIsWarning.result = result;
                    return responseIsWarning;
            }

            //#endregion method
        } catch (ex) {
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }

            switch (isUndNullEmp(result, currentMethod)?.result) {
                case true:
                    response = getResponse({ type: 1 });
                    response.msgText += `Error: 404 - url not found<br/>`;
                    response.msgText += `Message: ${ex?.message}<br/>`;
                    response.msgText += `Url: ${url}<br/>`;
                    response.msgText += `Data: ${JSON.stringify(result, null, 4)}`;
                    break;
                default:
                    response = getResponse({ type: -1 });
                    response.msgText += `Error: ${ex?.message}<br/>`;
                    response.msgText += `Url: ${url}<br/>`;
                    response.msgText += `Data: ${JSON.stringify(result, null, 4)}`;
                    break;
            }
        }
        return response;
    },

    //#endregion get

    //#region post

    post: async ({
        url = '',
        data = {},
        headers = {},
        subMethod = ''
    } = {}) => {
        //#region variables
        let response = getResponse({ type: 0 });
        const currentMethod = 'axios / post';
        let result = {};

        //#endregion variables
        try {
            //#region variables

            result = {};
            let options = {};

            //#region response is warning

            let responseIsWarning = getResponse({ type: 1, });
            responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                responseIsWarning.msgText += `Sub method: ${subMethod}<br/>`;
            }

            //#endregion response is warning

            //#endregion variables

            //#region method

            options = {
                method: 'POST',
                headers: isUndNullEmp({ data: headers, subMethod: currentMethod })?.result ?
                    { 'Content-Type': 'application/json', } :
                    { ...headers, 'Content-Type': 'application/json', },
                body: JSON.stringify(data),
            };

            result = await fetch(url, options,);
            response.result = await result.json();

            switch (result.status) {
                case 200:
                    if (!isUndNullEmp({ data: response?.result, subMethod: currentMethod })?.result &&
                        !isUndNull({ data: response?.result.isSuccess, subMethod: currentMethod })?.result &&
                        !isUndNull({ data: response?.result.isWarning, subMethod: currentMethod })?.result) {
                        response = response?.result;
                    }
                    break;
                default:
                    responseIsWarning.msgText += `Error: ${result.status} - ${result.statusText}<br/>`;
                    //responseIsWarning.msgText += `Code: ${result.status}<br/>`;
                    responseIsWarning.msgText += `Url: ${result.url}<br/>`;
                    responseIsWarning.msgText += `Data (result): ${JSON.stringify(result, null, 4)}<br/>`;
                    responseIsWarning.msgText += `Data: (response / result)${JSON.stringify(response?.result, null, 4)}`;
                    responseIsWarning.result = result;
                    return responseIsWarning;
            }

            //#endregion method
        } catch (ex) {
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }

            switch (isUndNullEmp(result, currentMethod)?.result) {
                case true:
                    response = getResponse({ type: 1 });
                    response.msgText += `Error: 404 - url not found<br/>`;
                    response.msgText += `Message: ${ex?.message}<br/>`;
                    response.msgText += `Url: ${url}<br/>`;
                    response.msgText += `Data: ${JSON.stringify(result, null, 4)}`;
                    break;
                //return response;
                default:
                    response = getResponse({ type: -1 });
                    response.msgText += `Error: ${ex?.message}<br/>`;
                    response.msgText += `Url: ${url}<br/>`;
                    response.msgText += `Data: ${JSON.stringify(result, null, 4)}`;
                    break;
                //return response;
            }
        }
        return response;
    },

    //#endregion post

    //#region put

    put: async ({
        url = '',
        data = {},
        headers = {},
        subMethod = ''
    } = {}) => {
        //#region variables
        let response = getResponse({ type: 0 });
        const currentMethod = 'axios / put';
        let result = {};

        //#endregion variables
        try {
            //#region variables

            result = {};
            let options = {};

            //#region response is warning

            let responseIsWarning = getResponse({ type: 1, });
            responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                responseIsWarning.msgText += `Sub method: ${subMethod}<br/>`;
            }

            //#endregion response is warning

            //#endregion variables

            //#region method

            options = {
                method: 'PUT',
                headers: isUndNullEmp({ data: headers, subMethod: currentMethod })?.result ?
                    { 'Content-Type': 'application/json', } :
                    { ...headers, 'Content-Type': 'application/json', },
                body: JSON.stringify(data),
            };

            result = await fetch(url, options,);
            response.result = await result.json();

            switch (result.status) {
                case 200:
                    break;
                default:
                    responseIsWarning.msgText += `Error: ${result.status} - ${result.statusText}<br/>`;
                    responseIsWarning.msgText += `Url: ${result.url}<br/>`;
                    responseIsWarning.msgText += `Data (result): ${JSON.stringify(result, null, 4)}<br/>`;
                    responseIsWarning.msgText += `Data: (response / result)${JSON.stringify(response?.result, null, 4)}`;
                    responseIsWarning.result = result;
                    return responseIsWarning;
            }

            //#endregion method
        } catch (ex) {
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }

            switch (isUndNullEmp(result, currentMethod)?.result) {
                case true:
                    response = getResponse({ type: 1 });
                    response.msgText += `Error: 404 - url not found<br/>`;
                    response.msgText += `Message: ${ex?.message}<br/>`;
                    response.msgText += `Url: ${url}<br/>`;
                    response.msgText += `Data: ${JSON.stringify(result, null, 4)}`;
                    break;
                default:
                    response = getResponse({ type: -1 });
                    response.msgText += `Error: ${ex?.message}<br/>`;
                    response.msgText += `Url: ${url}<br/>`;
                    response.msgText += `Data: ${JSON.stringify(result, null, 4)}`;
                    break;
            }
        }
        return response;
    }

    //#endregion put
}

export const sendMessage = ({
    msgType = 0,
    msgText = '',
    timer = 0,
    confirmButton = false,
    timerProgressBar = false,
    showUrlImage = false,
    customClass = {
        popup: settings?.html?.popup,
        confirmButton: settings?.html?.buttons?.primary,
        cancelButton: settings?.html?.buttons?.secondary,
    },
    languageId = 'en'
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'sendMessage';
    try {
        //console.log({ msgType, msgText, timer, confirmButton, timerProgressBar, showUrlImage });
        let swalProperties = {};
        if (msgType === -2) {
            Swal.close();
        } else {
            let msgTitle = null;
            switch (msgType) {
                case -1:
                    msgType = settings?.react?.sweetAlert2?.messages?.types?.error;
                    msgTitle = settings?.labels?.error?.[languageId];
                    break;
                case 0:
                    msgType = settings?.react?.sweetAlert2?.messages?.types?.success;
                    msgTitle = settings?.labels?.success[languageId];
                    break;
                case 1:
                    msgType = settings?.react?.sweetAlert2?.messages?.types?.warning;
                    msgTitle = settings?.labels?.warning[languageId];
                    break;
                case 2:
                    msgType = settings?.react?.sweetAlert2?.messages?.types?.info;
                    msgTitle = settings?.labels?.information[languageId];
                    break;
                default:
                    msgType = settings?.react?.sweetAlert2?.messages?.types?.question;
                    msgTitle = settings?.labels?.question[languageId];
                    break;
            }

            if (timerProgressBar) {
                let timerInterval;
                swalProperties = {
                    icon: msgType,
                    title: msgTitle,
                    html: msgText,
                    timer: timer !== null ? timer : null,
                    confirmButtonColor: settings.colors.successColorExp,
                    showConfirmButton: confirmButton,
                    timerProgressBar: timerProgressBar,
                    customClass: customClass,
                    //onBeforeOpen: () => {
                    didOpen: () => {
                        Swal.showLoading()
                        timerInterval = setInterval(() => {
                            //const content = Swal.getContent()

                            //if (content) {
                            //    const b = content.querySelector('strong')
                            //    if (b) {
                            //        //b.textContent = Swal.getTimerLeft()
                            //        percent = ((Swal.getTimerLeft() / parseInt(timer)) * 100).toFixed(0);
                            //        b.textContent = percent
                            //    }
                            //}
                        }, 100)
                    },
                    //onClose: () => {
                    willClose: () => {
                        clearInterval(timerInterval)
                    }
                };

                Swal.fire(swalProperties).then((result) => {
                    /* Read more about handling dismissals below */
                    if (result.dismiss === Swal.DismissReason.timer) {
                        console.info('I was closed by the timer')
                    }
                });
                //#region old code

                // } else {
                //     const localSwalProperties = {
                //         icon: msgType,
                //         title: msgTitle,
                //         html: msgText,
                //         timer: timer !== null ? timer : null,
                //         confirmButtonColor: settings.colors.successColorExp,
                //         showConfirmButton: confirmButton,
                //         timerProgressBar: timerProgressBar,
                //     };

                //     Swal.fire(localSwalProperties);
                // }

                //#endregion old code
            } else if (showUrlImage) {
                swalProperties = {
                    //icon: msgType,
                    title: msgTitle,
                    html: msgText,
                    imageUrl: settings?.gifs?.svg?.typing,
                    imageWidth: 50,
                    imageHeight: 50,
                    imageAlt: 'typingImage',
                    backdrop: true,
                    //timer: timer !== null ? timer : null,
                    confirmButtonColor: settings.colors.successColorExp,
                    showConfirmButton: confirmButton,
                    customClass: customClass,
                    //timerProgressBar: timerProgressBar,
                    didOpen: () => {
                        Swal.hideLoading();
                    },
                };

                Swal.fire(swalProperties);
            } else {
                swalProperties = {
                    icon: msgType,
                    title: msgTitle,
                    html: msgText,
                    //timer: timer !== null ? timer : null,
                    confirmButtonColor: settings.colors.successColorExp,
                    showConfirmButton: confirmButton,
                    customClass: customClass,
                    //timerProgressBar: timerProgressBar,
                    didOpen: () => {
                        Swal.hideLoading();
                    }
                };

                Swal.fire(swalProperties);
            }
        }
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.msgText = `Method: ${currentMethod}</br>`;
        response.msgText += `Error: ${ex?.message}<br/>`;
        console?.error(response);
    }
    return response;
};

export const sendMessageTwo = ({
    msgType = 0,
    msgText = '',
    timer = 0,
    confirmButton = false,
    confirmButtonText = 'Ok',
    confirmButtonColor = settings.colors.successColorExp,
    showProgressBar = false,
    showUrlImage = '',
    swal = undefined,
    msgTextUpdate = '',
    buttonsStyling = true,
    customClass = {
        popup: 'rounded-lg shadow border-0',
        // confirmButton: 'btn rounded-pill px-4 px-3',
        // cancelButton: 'btn rounded-pill px-4 px-3',
        confirmButton: settings?.html?.buttons?.primary,
        cancelButton: settings?.html?.buttons?.secondary,
    },
    languageId = 'en',
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'sendMessageTwo';
    try {
        //#region variables
        let swalLocal = {
            properties: {
                icon: '',
                title: '',
                html: msgText,
                timer: timer,
                showConfirmButton: confirmButton,
                confirmButtonText: confirmButtonText,
                confirmButtonColor: confirmButtonColor,
                //reverseButtons: true,
                timerProgressBar: showProgressBar,
                didOpen: {},
                willClose: {},
                buttonsStyling: buttonsStyling,
                customClass: customClass,
                allowOutsideClick: false,
            },
        };
        let timerInterval = {};
        const swalObj = (isUndNullEmp({ data: swal, subMethod: currentMethod })?.result ? Swal : swal);
        //const imageUrl = settings?.gifs?.svg?.typing;
        const imageUrl = settings?.gifs?.normal?.circle;

        //#endregion variables

        if (!isUndNullEmp({ data: msgText, subMethod: currentMethod })?.result) {
            swalLocal.properties.html = msgText?.replace('\n', '<br/>');
        }

        if (msgType === -2) {
            //Swal.close();
            swalObj.close();
        } else {
            switch (msgType) {
                case -1:
                    swalLocal.properties.icon = settings?.react?.sweetAlert2?.messages?.types?.error;
                    swalLocal.properties.title = settings?.labels?.error[languageId];
                    break;
                case 0:
                    swalLocal.properties.icon = settings?.react?.sweetAlert2?.messages?.types?.success;
                    swalLocal.properties.title = settings?.labels?.success[languageId];
                    break;
                case 1:
                    swalLocal.properties.icon = settings?.react?.sweetAlert2?.messages?.types?.warning;
                    swalLocal.properties.title = settings?.labels?.warning[languageId];
                    break;
                case 2:
                    swalLocal.properties.icon = settings?.react?.sweetAlert2?.messages?.types?.info;
                    swalLocal.properties.title = settings?.labels?.information[languageId];
                    break;
                case 3:
                    swalLocal.properties.icon = settings?.react?.sweetAlert2?.messages?.types?.question;
                    swalLocal.properties.title = settings?.labels?.question[languageId];
                    break;
                default:
                    swalLocal.properties.icon = '';
                    //swalLocal.properties.title = settings?.labels?.question?.[languageId];
                    break;
            }

            if (showProgressBar) {
                //#region old code
                // swal.properties = {
                //     icon: swal.icon,
                //     title: swal.title,
                //     html: swal.html,
                //     //timer: timer !== null ? timer : null,
                //     //showConfirmButton: confirmButton,
                //     //confirmButtonText: confirmButtonText,
                //     //confirmButtonColor: settings.colors.successColorExp,
                //     //timerProgressBar: showProgressBar,
                //     didOpen: () => {
                //         swalObj.showLoading();
                //         timerInterval = setInterval(() => {
                //             //const content = Swal.getContent()
                //             //if (content) {
                //             //    const b = content.querySelector('strong')
                //             //    if (b) {
                //             //        //b.textContent = Swal.getTimerLeft()
                //             //        percent = ((Swal.getTimerLeft() / parseInt(timer)) * 100).toFixed(0);
                //             //        b.textContent = percent
                //             //    }
                //             //}
                //         }, 100)
                //     },
                //     willClose: () => {
                //         clearInterval(timerInterval)
                //     }
                // };

                // Swal.fire(swalProperty).then((result) => {
                //   /* Read more about handling dismissals below */
                //   if (result.dismiss === Swal.DismissReason.timer) {
                //       console.log('I was closed by the timer')
                //   }
                // });
                //#endregion old code

                swalLocal.properties = {
                    ...swalLocal.properties,
                    didOpen: () => {
                        swalObj.showLoading();
                        timerInterval = setInterval(() => {
                            //const content = Swal.getContent()
                            //if (content) {
                            //    const b = content.querySelector('strong')
                            //    if (b) {
                            //        //b.textContent = Swal.getTimerLeft()
                            //        percent = ((Swal.getTimerLeft() / parseInt(timer)) * 100).toFixed(0);
                            //        b.textContent = percent
                            //    }
                            //}
                        }, 100)
                    },
                    willClose: () => {
                        clearInterval(timerInterval)
                    }
                };
            } else if (showUrlImage) {
                //#region old code
                // swal.properties = {
                //     //icon: swalMsgType,
                //     title: swal.title,
                //     html: swal.html,
                //     imageUrl: imageUrl,
                //     imageWidth: 50,
                //     imageHeight: 50,
                //     imageAlt: 'typingImage',
                //     backdrop: true,
                //     //timer: timer !== null ? timer : null,
                //     //showConfirmButton: confirmButton,
                //     //confirmButtonText: confirmButtonText,
                //     //confirmButtonColor: settings.colors.successColorExp,
                //     //timerProgressBar: showProgressBar,
                //     didOpen: () => {
                //         swalObj.hideLoading();
                //     },
                // };
                //#endregion old code

                swalLocal.properties = {
                    ...swalLocal.properties,
                    imageUrl: imageUrl,
                    imageWidth: 50,
                    imageHeight: 50,
                    imageAlt: 'loadingCircle',
                    backdrop: true,
                    didOpen: () => {
                        swalObj.hideLoading();
                    },
                };
            } else {
                //#region old code
                // swal_.properties = {
                //     icon: swal_.properties.icon,
                //     title: swal_.properties.title,
                //     html: swal_.html,
                //     //timer: timer !== null ? timer : null,
                //     //showConfirmButton: confirmButton,
                //     //confirmButtonText: confirmButtonText,
                //     //confirmButtonColor: settings.colors.successColorExp,
                //     //timerProgressBar: showProgressBar,
                //     didOpen: () => {
                //         swalObj.hideLoading();
                //     },
                // };
                //#endregion old code
                swalLocal.properties = {
                    ...swalLocal.properties,
                    didOpen: () => {
                        swalObj.hideLoading();
                    },
                };
            }

            if (!isUndNullEmp({ data: msgTextUpdate, subMethod: currentMethod })?.result) {
                delete swalLocal.properties.timer;
                delete swalLocal.properties.timerProgressBar;
                delete swalLocal.properties.didOpen;
                delete swalLocal.properties.imageUrl;

                swalLocal.properties.imageUrl = showUrlImage ? imageUrl : '';
                if (!showProgressBar) {
                    swalObj.hideLoading();
                } else {
                    swalObj.showLoading();
                }

                //swalLocal.properties.html = msgTextUpdate;
                swalLocal.properties.html = msgTextUpdate?.replace('\n', '<br/>');

                if (swalObj.isVisible()) {
                    swalObj.update(swalLocal.properties);
                }
            } else {
                swalObj.fire(swalLocal.properties);
            }

            //return localSwal;
            response.result = swalObj;
        }
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.msgText = `Method: ${currentMethod}</br>`;
        response.msgText += `Error: ${ex?.message}<br/>`;
        console?.error(response);
    }
    return response;
};

export const sendMessageCloseCurrentWindowAsync = async ({
    msgType = 0,
    msgText = '',
    closeWindow = false,
    urlGoTo = '',
    auth = {},
    isLogout = false,
    customClass = {
        popup: settings?.html?.popup,
        confirmButton: settings?.html?.buttons?.primary,
        cancelButton: settings?.html?.buttons?.secondary,
    },
    languageId = 'en',
} = {}) => {
    const currentMethod = 'sendMessageCloseCurrentWindowAsync';
    let response = getResponse({ type: 0 });
    try {
        //#region variables
        const swalObj = Swal;
        let msgTitle = '';
        let swalProperties = {};
        const { backend, labels, localStorage: settingsLs, react } = settings;
        //#endregion variables

        //#region logout
        if (!isUndNullEmp({ data: urlGoTo, subMethod: currentMethod })?.result) {
            if (urlGoTo === backend?.urls?.login &&
                !isUndNullEmp({ data: auth, subMethod: currentMethod })?.result &&
                !isUndNullEmp({ data: auth?.logout, subMethod: currentMethod })?.result) {
                isLogout = true;
            } else if (!isUndNullEmp({ data: auth, subMethod: currentMethod })?.result &&
                !isUndNullEmp({ data: auth?.logout, subMethod: currentMethod })?.result &&
                isLogout) {
                isLogout = true;
            }
        }
        //#endregion logout

        //#region show message
        if (!isUndNullEmp({ data: msgText, subMethod: currentMethod })?.result) {
            msgText = msgText?.replace('\n', '<br/>');
        }

        if (msgType === -2) {
            swalObj.close();
            return response;
        }
        switch (msgType) {
            case -1:
                msgType = react?.sweetAlert2?.messages?.types?.error;
                msgTitle = labels?.error?.[languageId];
                break;
            case 0:
                msgType = react?.sweetAlert2?.messages?.types?.success;
                msgTitle = labels?.success?.[languageId];
                break;
            case 1:
                msgType = react?.sweetAlert2?.messages?.types?.warning;
                msgTitle = labels?.warning?.[languageId];
                break;
            case 2:
                msgType = react?.sweetAlert2?.messages?.types?.info;
                msgTitle = labels?.information?.[languageId];
                break;
            default:
                msgType = react?.sweetAlert2?.messages?.types?.question;
                msgTitle = labels?.question?.[languageId];
                break;
        }

        swalProperties = {
            icon: msgType,
            title: msgTitle,
            html: msgText,
            timer: 0,
            //confirmButtonColor: settings.colors.successColorExp,
            confirmButtonColor: settings.colors.primaryColorExp,
            showConfirmButton: true,
            timerProgressBar: 0,
            customClass: customClass,
            didOpen: () => {
                swalObj.hideLoading();
            },
        };

        //#region close window / redirect page
        const { dismiss, isConfirmed, isDismissed } = await swalObj.fire({ ...swalProperties });
        if (isDismissed || isConfirmed) {
            if (urlGoTo === backend?.urls?.login || isLogout) localStorage.setItem(settingsLs?.redirectId, window?.location?.pathname);
            if (closeWindow) window.close();
            if (!isUndNullEmp({ data: urlGoTo, subMethod: currentMethod })?.result) {
                if (isLogout) auth?.logout({ subMethod: currentMethod });
                if (!isLogout && urlGoTo !== backend?.urls?.login) window.location.href = urlGoTo;
            } else if (isLogout) auth?.logout({ subMethod: currentMethod });
        } else {
            response = getResponse({ type: 1 });
            response.result = { dismiss, isConfirmed, isDismissed };
        }
        //#endregion close window / redirect page
        //#endregion show message
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.msgText = `Method: ${currentMethod}</br>`;
        response.msgText += `Error: ${ex?.message}<br/>`;
        console?.error(response);
    }
    return response;
};

// Centralized API response messaging helper (Mirror UI Standard)
export const handleResponseMessageAsync = async ({
    response = {},
    currentMethod = '',
    auth = {},
    languageId = 'en',
    setShowData = undefined,
    showDataValue = false,
    urlGoTo = '',
    closeWindow = false,
    isLogout = false,
} = {}) => {
    // const { messages } = settings;

    // Optional local state management
    if (typeof setShowData === 'function') {
        setShowData(showDataValue);
    }

    // Prioritize HTML version of the message for traceability
    let msgText = response?.msgTextHtml || response?.msgText;

    if ((isUndNullEmp({ data: msgText, subMethod: currentMethod })?.result) && (response?.msgType === 0 || response?.isSuccess)) {
        // msgText = `${messages?.processCompletedSuccessfully?.[languageId] || 'Process completed successfully'}.`;
        return;
    }

    // Call the generic SweetAlert wrapper
    await sendMessageCloseCurrentWindowAsync({
        msgType: response?.msgType,
        msgText: msgText,
        closeWindow: closeWindow,
        urlGoTo: urlGoTo || response?.urlGoTo || '',
        auth: auth,
        isLogout: isLogout,
        languageId: languageId,
    });
}

export const isValidDate = ({
    data = undefined,
    subMethod = ''
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'isValidDate';
    try {
        let localDateObj = new Date();
        if (!isUndNullEmp({ data: data._seconds, subMethod: currentMethod })?.result) {
            localDateObj = new Date(data._seconds * 1000);
        } else if (!isUndNullEmp({ data: data.seconds, subMethod: currentMethod })?.result) {
            localDateObj = new Date(data.seconds * 1000);
        } else {
            localDateObj = new Date(data);
        }

        response.result = (localDateObj.toString() !== 'Invalid Date');
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}<br/>`;
        console?.error(response);
        response.result = false;
    }
    return response;
}

export const isValidEmail = ({
    data = '',
} = {}) => {
    const re = /^(([^<>()\\[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(data)
}

export const isValidUrl = ({
    data = '',
    subMethod = ''
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'isValidUrl';
    try {
        var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        response.result = !!pattern.test(data);
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}<br/>`;
        response.result = false;
    }
    return response;
}

export const checkUrl = ({
    data = '',
    subMethod = ''
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'checkUrl';
    try {
        //http://www.deleteme.com/
        //http://www.chejconsultor.com.ve

        const httpObj = {
            http: 'http:',
            https: 'https:',
            twoSlash: '//',
            www: 'www.',
        }

        if (data.toLowerCase()?.indexOf(httpObj.www) < 0) {
            data = `${httpObj.www}${data}`;
        }

        if (data.toLowerCase()?.indexOf(httpObj.http) < 0 && data.toLowerCase()?.indexOf(httpObj.https) < 0) {
            data = `${httpObj.https}${data}`;
        }

        if (data.toLowerCase()?.indexOf(httpObj.twoSlash) < 0) {
            data = data?.replace(httpObj.http, `${httpObj.http}${httpObj.twoSlash}`);
            data = data?.replace(httpObj.https, `${httpObj.https}${httpObj.twoSlash}`);
        }

        response.result = data;
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}<br/>`;
        response.result = '#nothing';
    }
    return response;
}

export const isValidPhoneNumber = ({
    data = ''
} = {}) => {
    //const re = /^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
    const re = /^(\+\d{1,2}\s?)?1?-?\.?\s?\(?\d{1,4}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;
    return re.test(data);
}

export const isValidPhoneNumberRegExp = () => {
    return new RegExp(/^(\+\d{1,2}\s?)?1?-?\.?\s?\(?\d{1,4}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/);
}

export const styles = Object.freeze({
    appLogo: {
        height: 45,
        width: 70,
    },

    appLogoHome: {
        // //height: '240px',
        // width: '250px',
        // maxWidth: '100%',
        // height: 'auto',
        height: '100px',
        width: 'auto',
    },

    appLogoHomeSupplier: {
        height: '80px',
        width: 'auto',
    },

    cardHeaderLogo: {
        width: '25px',
        height: '25px',
        objectFit: 'contain',
    },

    cardHeaderSaleDetailLogo: {
        height: 55,
        width: 55,
    },

    graphRates: {
        minHeight: 250,
        height: 250,
        maxHeight: 250,
        maxWidth: '100%',
    },

    labelMsgAlert: {
        fontSize: 12,
        color: 'orangered'
    },

    loginIcon: {
        height: 33,
        width: 33,
    },

    labelMsgInfo: {
        fontSize: 12,
        color: '#18A2B8'
    },

    inputMsgAlert: {
        fontSize: 12,
        color: 'orangered'
    },

    navStyle: {
        color: 'white',
    },

    titleUser: {
        marginBottom: 10,
    },

    loginBox: {
        margin: '0 auto'
    },

    userLogin: {
        width: 30,
        height: 'auto',
        maxWidth: '100%'
    },

    logoAppSmall: {
        width: 40,
        height: 'auto',
        maxWidth: '100%'
    },

    paragrapJustify: {
        textIndent: 4,
        textAlign: 'justify'
    },

    profileUserPicture: {
        aspectRatio: 1,
        flex: 1,
        height: 100,
        width: 100,

    },

    leftMenuUserPicture: {
        aspectRatio: 1,
        flex: 1,
        height: 40,
        width: 40,
    },
});

export const getLanguageObj = ({
    subMethod = ''
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'getLanguageObj';
    const localFormat = getGlobalFormat();
    try {
        //#region variables
        const languageId = navigator?.language || navigator?.uerLanguage;
        //#endregion variables

        //#region process
        if (isUndNullEmp({ data: languageId, subMethod: currentMethod })?.result) {
            response.result = settings?.languages?.enUS;
        } else {
            switch (languageId) {
                case settings?.languages?.enUS?.code:
                    response.result = settings?.languages?.enUS;
                    break;
                case settings?.languages?.es?.code:
                    response.result = settings?.languages?.es;
                    break;
                case settings?.languages?.esAR?.code:
                    response.result = settings?.languages?.esAR;
                    break;
                case settings?.languages?.esCL?.code:
                    response.result = settings?.languages?.esCL;
                    break;
                case settings?.languages?.esCO?.code:
                    response.result = settings?.languages?.esCO;
                    break;
                case settings?.languages?.esMX?.code:
                    response.result = settings?.languages?.esMX;
                    break;
                case settings?.languages?.esUS?.code:
                    response.result = settings?.languages?.esUS;
                    break;
                case settings?.languages?.esVE?.code:
                    response.result = settings?.languages?.esVE;
                    break;
                case settings?.languages?.es419?.code:
                    response.result = settings?.languages?.es419;
                    break;
                default:
                    response.result = settings?.languages?.enUS;
                    break;
            }
        }
        //#endregion process
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.msgText = `Method: ${currentMethod}</br>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}<br/>`;
        response.result = localFormat;
        console?.error(response);
    }
    return response;
}

export const setDateTimeFormat = ({
    seconds = 0,
    type = '',
    format = '',
    withSeconds = true
} = {}) => {
    const dateTime = seconds > 0 ? new Date(seconds * 1000) : new Date();
    let formatDateTime = ''

    switch (type) {
        //case 'd-m-y':
        case settings.react.tempusDominus.formats.date.dmyTwo:
            //formatDateTime = 'DD-MM-YYYY';
            formatDateTime = settings.react.tempusDominus.formats.date.DDMMYYYYTwo;
            break;
        //case 'm-d-y':
        case settings.react.tempusDominus.formats.date.mdyTwo:
            //formatDateTime = 'MM-DD-YYYY';
            formatDateTime = settings.react.tempusDominus.formats.date.MMDDYYYYTwo;
            break;
        //case 'y-m-d':
        case settings.react.tempusDominus.formats.date.ymdTwo:
            //formatDateTime = 'YYYY-MM-DD';
            formatDateTime = settings.react.tempusDominus.formats.date.YYYYMMDDTwo;
            break;
        //case 'd/m/y':
        case settings.react.tempusDominus.formats.date.dmy:
            //formatDateTime = 'DD/MM/YYYY';
            formatDateTime = settings.react.tempusDominus.formats.date.DDMMYYYY;
            break;
        //case 'm/d/y':
        case settings.react.tempusDominus.formats.date.mdy:
            //formatDateTime = 'MM/DD/YYYY';
            formatDateTime = settings.react.tempusDominus.formats.date.MMDDYYYY;
            break;
        //case 'y/m/d':
        case settings.react.tempusDominus.formats.date.ymd:
            //formatDateTime = 'YYYY/MM/DD';
            formatDateTime = settings.react.tempusDominus.formats.date.YYYYMMDD;
            break;
        case '':
            formatDateTime = '';
            break;
        default:
            //formatDateTime = 'MM/DD/YYYY';
            formatDateTime = settings.react.tempusDominus.formats.date.MMDDYYYY;
            break;
    }

    switch (type) {
        case '':
            switch (format) {
                case 0:
                    formatDateTime += '';
                    break;
                case 24:
                    if (withSeconds) {
                        formatDateTime += settings.react.tempusDominus.formats.time.HHmmss;
                    } else {
                        formatDateTime += settings.react.tempusDominus.formats.time.HHmm;
                    }
                    break;
                default:
                    if (withSeconds) {
                        formatDateTime += settings.react.tempusDominus.formats.time.hhmmssa;
                    } else {
                        formatDateTime += settings.react.tempusDominus.formats.time.hhmma;
                    }
                    break;
            };
            break;
        default:
            switch (format) {
                case 0:
                    formatDateTime += '';
                    break;
                case 24:
                    if (withSeconds) {
                        formatDateTime += ` - ${settings.react.tempusDominus.formats.time.HHmmss}`;
                    } else {
                        formatDateTime += ` - ${settings.react.tempusDominus.formats.time.HHmm}`;
                    }
                    break;
                default:
                    if (withSeconds) {
                        formatDateTime += ` - ${settings.react.tempusDominus.formats.time.hhmmssa}`;
                    } else {
                        formatDateTime += ` - ${settings.react.tempusDominus.formats.time.hhmma}`;
                    }
                    break;
            };
            break;
    }

    let dateTimeFormat = moment(dateTime).format(formatDateTime);
    return dateTimeFormat;
}

export const setDateTimeFormatTwo = ({
    date = '',
    type = '',
    format = 0,
    addTime = false,
    withSeconds = true
} = {}) => {
    const currentMethod = 'setDateTimeFormatTwo';
    //const dateTime = new Date(!isUndefined(addTime) && addTime ? (date + 'T12:00:00') : date);
    const dateTime = new Date((!isUndNull({ data: addTime, subMethod: currentMethod })?.result && addTime && date?.indexOf('T') < 0) ? (date + 'T12:00:00') : date);

    let formatDateTime = ''

    switch (type) {
        //case 'd-m-y':
        case settings.react.tempusDominus.formats.date.dmyTwo:
            //formatDateTime = 'DD-MM-YYYY';
            formatDateTime = settings.react.tempusDominus.formats.date.DDMMYYYYTwo;
            break;
        //case 'm-d-y':
        case settings.react.tempusDominus.formats.date.mdyTwo:
            //formatDateTime = 'MM-DD-YYYY';
            formatDateTime = settings.react.tempusDominus.formats.date.MMDDYYYYTwo;
            break;
        //case 'y-m-d':
        case settings.react.tempusDominus.formats.date.ymdTwo:
            //formatDateTime = 'YYYY-MM-DD';
            formatDateTime = settings.react.tempusDominus.formats.date.YYYYMMDDTwo;
            break;
        //case 'd/m/y':
        case settings.react.tempusDominus.formats.date.dmy:
            //formatDateTime = 'DD/MM/YYYY';
            formatDateTime = settings.react.tempusDominus.formats.date.DDMMYYYY;
            break;
        //case 'm/d/y':
        case settings.react.tempusDominus.formats.date.mdy:
            //formatDateTime = 'MM/DD/YYYY';
            formatDateTime = settings.react.tempusDominus.formats.date.MMDDYYYY;
            break;
        //case 'y/m/d':
        case settings.react.tempusDominus.formats.date.ymd:
            //formatDateTime = 'YYYY/MM/DD';
            formatDateTime = settings.react.tempusDominus.formats.date.YYYYMMDD;
            break;
        case '':
            formatDateTime = '';
            break;
        default:
            //formatDateTime = 'MM/DD/YYYY';
            formatDateTime = settings.react.tempusDominus.formats.date.MMDDYYYY;
            break;
    }

    switch (type) {
        case '':
            switch (format) {
                case 0:
                    formatDateTime += '';
                    break;
                case 24:
                    if (withSeconds) {
                        formatDateTime += settings.react.tempusDominus.formats.time.HHmmss;
                    } else {
                        formatDateTime += settings.react.tempusDominus.formats.time.HHmm;
                    }
                    break;
                default:
                    if (withSeconds) {
                        formatDateTime += settings.react.tempusDominus.formats.time.hhmmssa;
                    } else {
                        formatDateTime += settings.react.tempusDominus.formats.time.hhmma;
                    }
                    break;
            };
            break;
        default:
            switch (format) {
                case 0:
                    formatDateTime += '';
                    break;
                case 24:
                    if (withSeconds) {
                        formatDateTime += ` - ${settings.react.tempusDominus.formats.time.HHmmss}`;
                    } else {
                        formatDateTime += ` - ${settings.react.tempusDominus.formats.time.HHmm}`;
                    }
                    break;
                default:
                    if (withSeconds) {
                        formatDateTime += ` - ${settings.react.tempusDominus.formats.time.hhmmssa}`;
                    } else {
                        formatDateTime += ` - ${settings.react.tempusDominus.formats.time.hhmma}`;
                    }
                    break;
            };
            break;
    }

    let dateTimeFormat = moment(dateTime).format(formatDateTime);
    return dateTimeFormat;
}

export const setDateTimeFormatGlobal = ({
    date = {},
    type = settings.react.tempusDominus.formats.date.mdy,
    format = 0,
    addTime = false,
    withSeconds = true,
    subMethod = '',
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'setDateTimeFormatGlobal';
    try {
        if (!isUndNullEmp({ data: date.seconds, subMethod: currentMethod })?.result) {
            response.result = setDateTimeFormat({ seconds: date.seconds, type: type, format: format, withSeconds: withSeconds });
        } else if (!isUndNullEmp({ data: date._seconds, subMethod: currentMethod })?.result) {
            response.result = setDateTimeFormat({ seconds: date._seconds, type: type, format: format, withSeconds: withSeconds });
        } else {
            response.result = setDateTimeFormatTwo({ date: date, type: type, format: format, addTime: addTime, withSeconds: withSeconds });
        }
    } catch (ex) {
        response.result = '00/00/0000';
        response = getResponse({ type: -1 });
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}<br/>`;
        console?.error(response);
    }
    return response;
}

export const setDateTimeFormatGlobalString = ({
    date = '',
    dateFormat = settings.react.tempusDominus.formats.date.mdy,
    timeFormat = 0,
    withSeconds = false,
    languageId = 'en',
    subMethod = ''
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'setDateTimeFormatGlobalString';
    try {
        //#region variables
        let localHour24 = '';
        const localDateTime = {
            day: '',
            month: '',
            year: '',
            hour24: '',
            hour12: '',
            ampm: 'am',
            minutes: '',
            seconds: '',
            finalData: '',
        };
        //#region response is warning
        let responseIsWarning = getResponse({ type: 1, });
        responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            responseIsWarning.msgText += `Sub method: ${subMethod}<br/>`;
        }
        //#endregion response is warning
        //#endregion variables

        //#region check data (date)
        // if (isUndNullEmp({ data: date, subMethod: currentMethod })?.result ||
        //     typeof date !== settings?.nativeObjs?.string ||
        //     typeof date !== settings?.nativeObjs?.date) {
        //     console.log(date);
        //     responseIsWarning.msgText += `Error: Date. ${settings?.messages?.itIsRequired[languageId]}`;
        //     responseIsWarning.result = '00/00/0000';
        //     responseIsWarning.msgTextHtml = date;
        //     console?.error(responseIsWarning);
        //     return responseIsWarning;
        // }
        if (isUndNullEmp({ data: date, subMethod: currentMethod })?.result) date = new Date()?.toISOString();
        if (typeof date !== settings?.nativeObjs?.string && typeof date === settings?.nativeObjs?.object) date = date?.toISOString();
        //#endregion check data (date)

        //#region process
        localHour24 = date.substring(11, 13);
        localDateTime.day = date.substring(8, 10);
        localDateTime.month = date.substring(5, 7);
        localDateTime.year = date.substring(0, 4);
        //localDateTime.hour24 = date.substring(11, 13);
        localDateTime.hour24 = localHour24
        if (parseInt(localHour24) > 12) {
            localDateTime.hour12 = (parseInt(localHour24) - 12) <= 9 ? `0${(parseInt(localHour24) - 12)}` : `${parseInt(localHour24)}`;
        } else {
            localDateTime.hour12 = parseInt(localHour24) <= 9 ? `0${parseInt(localHour24)}` : `${parseInt(localHour24)}`;
        }
        if (parseInt(localHour24) >= 12) {
            localDateTime.ampm = 'pm';
        }
        localDateTime.minutes = date.substring(14, 16);
        localDateTime.seconds = date.substring(17, 19);

        switch (dateFormat) {
            //case 'd-m-y':
            case settings.react.tempusDominus.formats.date.dmyTwo:
                localDateTime.finalData = `${localDateTime.day}-${localDateTime.month}-${localDateTime.year}`;
                break;
            //case 'm-d-y':
            case settings.react.tempusDominus.formats.date.mdyTwo:
                localDateTime.finalData = `${localDateTime.month}-${localDateTime.day}-${localDateTime.year}`;
                break;
            //case 'y-m-d':
            case settings.react.tempusDominus.formats.date.ymdTwo:
                localDateTime.finalData = `${localDateTime.year}-${localDateTime.month}-${localDateTime.day}`;
                break;
            //case 'd/m/y':
            case settings.react.tempusDominus.formats.date.dmy:
                localDateTime.finalData = `${localDateTime.day}/${localDateTime.month}/${localDateTime.year}`;
                break;
            //case 'm/d/y':
            case settings.react.tempusDominus.formats.date.mdy:
                localDateTime.finalData = `${localDateTime.month}/${localDateTime.day}/${localDateTime.year}`;
                break;
            //case 'y/m/d':
            case settings.react.tempusDominus.formats.date.ymd:
                localDateTime.finalData = `${localDateTime.year}/${localDateTime.month}/${localDateTime.day}`;
                break;
            case '':
                localDateTime.finalData = '';
                break;
            default:
                //case 'm/d/y':
                localDateTime.finalData = `${localDateTime.month}/${localDateTime.day}/${localDateTime.year}`;
                break;
        }

        switch (dateFormat) {
            case '':
                switch (timeFormat) {
                    case 0:
                        localDateTime.finalData += '';
                        break;
                    case 24:
                        if (withSeconds) {
                            //'HH:mm:ss';
                            localDateTime.finalData += `${localDateTime.hour24}:${localDateTime.minutes}:${localDateTime.seconds}`;
                        } else {
                            //'HH:mm';
                            localDateTime.finalData += `${localDateTime.hour24}:${localDateTime.minutes}`;
                        }
                        break;
                    default:
                        if (withSeconds) {
                            //'hh:mm:ss a';
                            localDateTime.finalData += `${localDateTime.hour12}:${localDateTime.minutes}:${localDateTime.seconds} ${localDateTime.ampm}`;
                        } else {
                            //'hh:mm a';
                            localDateTime.finalData += `${localDateTime.hour12}:${localDateTime.minutes} ${localDateTime.ampm}`;
                        }
                        break;
                };
                break;
            default:
                switch (timeFormat) {
                    case 0:
                        localDateTime.finalData += '';
                        break;
                    case 24:
                        if (withSeconds) {
                            //' - HH:mm:ss';
                            localDateTime.finalData += ` - ${localDateTime.hour24}:${localDateTime.minutes}:${localDateTime.seconds}`;
                        } else {
                            //' - HH:mm';
                            localDateTime.finalData += ` - ${localDateTime.hour24}:${localDateTime.minutes}`;
                        }
                        break;
                    default:
                        if (withSeconds) {
                            //' - hh:mm:ss a';
                            localDateTime.finalData += ` - ${localDateTime.hour12}:${localDateTime.minutes}:${localDateTime.seconds} ${localDateTime.ampm}`;
                        } else {
                            //' - hh:mm a';
                            localDateTime.finalData += ` - ${localDateTime.hour12}:${localDateTime.minutes} ${localDateTime.ampm}`;
                        }
                        break;
                };
                break;
        }
        //#endregion process

        //#region set final data
        response.result = localDateTime.finalData;
        //#endregion set final data
    } catch (ex) {
        response.result = '00/00/0000';
        response = getResponse({ type: -1 });
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}<br/>`;
        console?.error(response);
        console?.error(typeof date);
    }
    return response;
}

export const setSeparatorsNumbers = ({
    number = 0,
    withDecimals = true,
    consoleLogErrorShow = true,
    subMethod = ''
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'setSeparatorsNumbers';
    try {
        //#region variables
        let languageObj = getGlobalFormat();
        languageObj = getLanguageObj({ subMethod: currentMethod })?.result;
        let numberObj = {
            str: !isUndNull({ data: number, subMethod: currentMethod, })?.result ? (!isNaN(number) ? number?.toString() : number) : '',
            new: '',
            decimals: '',
        };
        const decimalPlaces = withDecimals ? settings?.numberPositions?.decimalPlaces : 0;
        //#region old code
        // const decimalSeparator = '.';
        // const thousendSeparator = ',';
        //#endregion old code
        const decimalSeparator = languageObj?.numbers?.separators?.decimals || '.';
        const thousandSeparator = languageObj?.numbers?.separators?.thousands || ',';
        //let decimalPlaces = decimalPlaces;
        let flat = 1;
        const decimalPosition = numberObj?.str?.indexOf('.');
        //#endregion variables

        //#region check decimal separators
        numberObj.str = numberObj?.str?.replace('.', decimalSeparator);
        //#endregion check decimal separators

        //#region check decimals / decimal places
        if (decimalPlaces !== 0) {
            if (decimalPosition < 0) {
                //numberString += `${decimalSeparator}${repeat('0', decimals)}`;
                numberObj.str += `${decimalSeparator}${'0'?.repeat(decimalPlaces)}`;
            } else {
                //#region old code
                //const localDecimals = numberString?.substr((decimalPosition + 1), decimalPlaces);
                //#endregion old code
                const localDecimals = numberObj?.str?.slice((decimalPosition + 1), (decimalPlaces + (decimalPosition + 1)));
                if (localDecimals.length !== decimalPlaces) {
                    numberObj.str += `${'0'?.repeat(decimalPlaces - localDecimals.length)}`;
                }
            }
        }
        //#endregion check decimals / decimal places

        //#region remove decimals info (excedent)
        if (!withDecimals && decimalPosition > 0) {
            numberObj.str = numberObj?.str?.slice(0, decimalPosition);
        } else if (withDecimals && decimalPosition > 0 && decimalPlaces > 0) {
            numberObj.decimals = numberObj?.str.slice(decimalPosition + 1);
            if (numberObj?.decimals?.length > decimalPlaces) {
                console?.log(numberObj?.decimals);
                numberObj.str = numberObj?.str?.slice(0, ((decimalPosition + 1) + decimalPlaces));
            }
        }
        //#endregion remove decimals info (excedent)

        for (var index = numberObj?.str?.length + 1; index >= 0; index--) {
            if (flat === (withDecimals ? decimalPlaces + 6 : 5) || flat === (withDecimals ? decimalPlaces + 9 : 8) || flat === (withDecimals ? decimalPlaces + 12 : 11)) {
                //#region old code
                //newNumber = `${thousandSeparator}${numberString?.substr(index, 1)}` + newNumber;
                //#endregion old code
                numberObj.new = `${thousandSeparator}${numberObj?.str?.slice(index, (index + 1))}` + numberObj.new;
            } else {
                //#region old code
                //newNumber = numberString?.substr(index, 1) + newNumber;
                //#region old code
                numberObj.new = numberObj?.str?.slice(index, (index + 1)) + numberObj.new;
            }
            flat++;
        }

        //#region old code
        //if (newNumber?.substr(0, 1) === ',') {
        //#endregion old code
        //#region old coe
        // if (newNumber?.substr(0, 1) === thousandSeparator) {
        //     newNumber = newNumber?.substr(1);
        // }
        //#endregion old coe
        if (numberObj.new?.slice(0, 1) === thousandSeparator) {
            numberObj.new = numberObj.new?.slice(1);
        }
        //#region old coe
        // if (numberObj?.new?.indexOf('-,') >= 0) {
        //     numberObj.new = numberObj.new?.replace('-,', '-');
        // }
        //#endregion old coe
        if (numberObj.new?.indexOf(`-${thousandSeparator}`) >= 0) {
            numberObj.new = numberObj.new?.replace(`-${thousandSeparator}`, '-');
        }

        response.result = numberObj.new;
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}<br/>`;
        if (consoleLogErrorShow) {
            console?.error(response);
        }
        response.result = 'Check error';
    }
    return response;
}

export const numberTruncator = ({
    number = 0,
    decimalPlaces = settings?.numberPositions?.decimalPlaces
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'numberTruncator';
    try {
        //#region variables
        let localNumber = Math.pow(10, decimalPlaces);
        //#endregion variables

        //#region process
        //console.log({number, localNumber, decimalPlaces});
        response.result = Math.floor(number * localNumber) / localNumber;
        //#endregion process
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.result = setNumberFour({ number: 0.00, type: 'd' })?.result;
        response.msgText = `Method: ${currentMethod}<br/>`;
        response.msgText += `Error: ${ex?.message}<br/>`;
    }
    return response;
}

export const setNumberFour = ({
    number = 0,
    type = 'd'
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'setNumberFour';
    try {
        //#region variables
        let localNumber = {};
        let localZero = '0';
        let localDecimalPlaces = settings?.numberPositions?.decimalPlaces;
        //#region old code

        //let localTruncateDecimalPlaces = 6;

        //#endregion old code
        let localTruncateDecimalPlaces = 15;
        localZero = `${localZero}.${localZero?.repeat(localDecimalPlaces)}`;
        let localZeroNumber = parseFloat(Number(localZero).toFixed(localDecimalPlaces));

        //#endregion variables

        //#region procesos

        switch (type) {
            case 'd':
                response = countDecimals({ number: number });
                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }

                localNumber = parseFloat(Number(number).toFixed(localTruncateDecimalPlaces));

                if (localDecimalPlaces !== response?.result) {
                    response.result = (isNaN(localNumber) ? localZeroNumber : numberTruncator({ number: localNumber, decimalPlaces: localDecimalPlaces })?.result);
                } else {
                    response.result = (isNaN(localNumber) ? localZeroNumber : localNumber);
                }
                break;
            default:
                localNumber = parseInt(Number(number).toString());
                response.result = (isNaN(localNumber) ? 0 : localNumber);
                break;
        }

        //#endregion procesos
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.result = 0.00;
        response.msgText = `Method: ${currentMethod}<br/>`;
        response.msgText += `Error: ${ex?.message}<br/>`;
    }
    return response;
}

export const countDecimals = ({
    number = 0
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'countDecimals';
    try {
        if (Math.floor(number.valueOf()) === number.valueOf()) {
            response.result = 0;
            return response;
        }

        var localNumberStr = number.toString();
        if (localNumberStr?.indexOf(".") !== -1 && localNumberStr?.indexOf("-") !== -1) {
            response.result = localNumberStr.split("-")[1] || 0;
            return response;
        } else if (localNumberStr?.indexOf(".") !== -1) {
            response.result = localNumberStr.split(".")[1].length || 0;
            return response;
        }
        response.result = localNumberStr.split("-")[1] || 0;
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.result = 0.00;
        response.msgText = `Method: ${currentMethod}<br/>`;
        response.msgText += `Error: ${ex?.message}<br/>`;
    }
    return response;
}

export const toastSweetalertAsync = async ({
    position = '',
    showConfirmButton = false,
    timer = 0,
    timerProgressBar = false,
    icon = '',
    iconColor = '',
    iconHtml = '',
    background = '',
    color = '',
    title = '',
    html = '',
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'toastSweetalertAsync';
    try {
        await Swal.mixin({
            toast: true,
            position: position,
            showConfirmButton: showConfirmButton,
            timer: timer,
            timerProgressBar: timerProgressBar,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer);
                toast.addEventListener('mouseleave', Swal.resumeTimer);
            },
        }).fire({
            icon: icon,
            iconColor: iconColor,
            iconHtml: iconHtml,
            background: background,
            color: color,
            title: title,
            html: html,
            customClass: {
                popup: 'shadow-lg border-0 rounded-lg',
                title: 'text-dark font-weight-bold',
                htmlContainer: 'text-muted ml-2'
            }
        });
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.msgText = `Method: ${currentMethod}</br>`;
        response.msgText += `Error: ${ex?.message}<br/>`;
        console?.error(response);
    }
    return response;
}

export const toastSweetalert = ({
    position = '',
    showConfirmButton = false,
    timer = 0,
    timerProgressBar = false,
    icon = '',
    iconColor = '',
    iconHtml = '',
    background = '',
    color = '',
    title = '',
    html = '',
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'toastSweetalert';
    try {
        Swal.mixin({
            toast: true,
            position: position,
            showConfirmButton: showConfirmButton,
            timer: timer,
            timerProgressBar: timerProgressBar,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer);
                toast.addEventListener('mouseleave', Swal.resumeTimer);
            },
        }).fire({
            icon: icon,
            iconColor: iconColor,
            iconHtml: iconHtml,
            background: background,
            color: color,
            title: title,
            html: html,
            customClass: {
                popup: 'shadow-lg border-0 rounded-lg',
                title: 'text-dark font-weight-bold',
                htmlContainer: 'text-muted ml-2'
            }
        });
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.msgText = `Method: ${currentMethod}</br>`;
        response.msgText += `Error: ${ex?.message}<br/>`;
        console?.error(response);
    }
    return response;
}

// export const checkUser = ({
//     email = '',
//     languageId = 'en',
//     subMethod = ''
// } = {}) => {
//     let response = getResponse({ type: 0 });
//     const currentMethod = 'checkIfUserIsAdmin';
//     try {
//         response = getResponse({ type: 1 });
//         //response.msgText = 'This user is not admin.<br/>';
//         response.msgText = `${settings?.messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageId]}<br/>`;
//         response.msgText += `${settings?.labels?.email?.[languageId]}: <b>${isUndNullEmp({ data: email, subMethod: currentMethod })?.result ? 'Anonymous' : email}</b>`;

//         if (!isUndNullEmp({ data: email, subMethod: currentMethod })?.result && isValidEmail({ data: email })) {
//             if (email !== settings.users.sysAdmin.email) {
//                 //response.result = 'user';
//                 response.isWarning = true;
//                 response.result = settings?.roles?.user;
//             } else {
//                 //response.result = 'admin';
//                 response = getResponse({ type: 0 });
//                 response.result = settings?.roles?.admin;
//             }
//         } else {
//             //response.result = 'anonymous';
//             response = getResponse({ type: 1 });
//             response.result = settings?.roles?.anonymous;
//         }
//     } catch (ex) {
//         response = getResponse({ type: -1 });
//         response.msgText = `Method: ${currentMethod}<br/>`;
//         if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
//             response.msgText += `Sub method: ${subMethod}<br/>`;
//         }
//         response.msgText += `Error: ${ex?.message}<br/>`;
//         response.result = 'anonymous';
//     }
//     return response;
// }

export const checkIfUserIsAdmin = ({
    email = '',
    languageId = 'en',
    subMethod = ''
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'checkIfUserIsAdmin';
    try {
        response = getResponse({ type: 1 });
        //response.msgText = 'This user is not admin.<br/>';
        response.msgText = `${settings?.messages?.youDoNotHaveSufficientPrivilegesToRunThisProcess?.[languageId]}<br/>`;
        response.msgText += `${settings?.labels?.email?.[languageId]}: <b>${isUndNullEmp({ data: email, subMethod: currentMethod })?.result ? 'Anonymous' : email}</b>`;

        if (!isUndNullEmp({ data: email, subMethod: currentMethod })?.result && isValidEmail({ data: email })) {
            if (email !== settings.users.admins.admin01.email) {
                //response.result = 'user';
                response.isWarning = true;
                response.result = settings?.roles?.user;
            } else {
                //response.result = 'admin';
                response = getResponse({ type: 0 });
                response.result = settings?.roles?.admin;
            }
        } else {
            //response.result = 'anonymous';
            response = getResponse({ type: 1 });
            response.result = settings?.roles?.anonymous;
        }
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}<br/>`;
        response.result = settings?.roles?.anonymous;
    }
    return response;
}

export const charactersRemainingGet = ({
    text = '',
    maxLength = 0,
    msgText = '',
    subMethod = ''
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'charactersRemainingGet';
    try {
        //response.result = `${text.length - maxLength} ${msgText}`;
        response.result = `${msgText} <b>${maxLength - text.length}</b>`;
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`
        }
        response.msgText += `Error: ${ex?.message}<br/>`;
        response.result = 'Status - error'
        sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
    }
    return response;
}

export const awaitDelayAsync = ({
    delayTime = 0
}) => new Promise(
    resolve => setTimeout(resolve, delayTime)
);

export const badgetStatusGeneric = ({
    type = 0,
    value = '',
} = {}) => {
    switch (type) {
        case -1:
            return `<span class='badge badge-danger'>${value}</span>`;
        case 0:
            return `<span class='badge badge-success'>${value}</span>`;
        case 1:
            return `<span class='badge badge-primary'>${value}</span>`;
        case 2:
            return `<span class='badge badge-warning'>${value}</span>`;
        case 3:
            return `<span class='badge badge-info'>${value}</span>`;
        case 4:
            return `<span class='badge badge-default'>${value}</span>`;
        default:
            return `<span class='badge badge-secondary'>${value}</span>`;
    }
}

export const dataTableLanguaje = ({
    code = ''
} = {}) => {
    switch (code) {
        case 'es':
            return {
                sProcessing: 'Procesando...',
                //sLengthMenu: 'Mostrar _MENU_ registros',
                sLengthMenu: 'Mostrar _MENU_',
                sZeroRecords: 'No se encontraron resultados',
                sEmptyTable: 'Ningún dato disponible en esta tabla',
                //sInfo: 'Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros',
                sInfo: 'Mostrando _START_ al _END_ de _TOTAL_ registros',
                //sInfoEmpty: 'Mostrando registros del 0 al 0 de un total de 0 registros',
                sInfoEmpty: 'Mostrando 0 al 0 de 0 registros',
                //sInfoFiltered: '(filtrado de un total de _MAX_ registros)',
                sInfoFiltered: '',
                sInfoPostFix: '',
                //sSearch: 'Buscar:',
                sSearch: 'Buscar',
                sUrl: '',
                sInfoThousands: ',',
                sLoadingRecords: 'Cargando...',
                oPaginate: {
                    sFirst: 'Primero',
                    sLast: 'Último',
                    sNext: 'Siguiente',
                    sPrevious: 'Anterior'
                },
                oAria: {
                    sSortAscending: ': Activar para ordenar la columna de manera ascendente',
                    sSortDescending: ': Activar para ordenar la columna de manera descendente'
                }
            }

        default:
            return {
                sEmptyTable: 'No data available in table',
                sInfo: 'Showing _START_ to _END_ of _TOTAL_ entries',
                sInfoEmpty: 'Showing 0 to 0 of 0 entries',
                sInfoFiltered: '(filtered from _MAX_ total entries)',
                sInfoPostFix: '',
                sInfoThousands: ',',
                sLengthMenu: 'Show _MENU_ entries',
                sLoadingRecords: 'Loading...',
                sProcessing: 'Processing...',
                sSearch: 'Search:',
                sZeroRecords: 'No matching records found',
                oPaginate: {
                    sFirst: 'First',
                    sLast: 'Last',
                    sNext: 'Next',
                    sPrevious: 'Previous'
                },
                oAria: {
                    sSortAscending: ': activate to sort column ascending',
                    sSortDescending: ': activate to sort column descending'
                }
            }
    }
}

export const getDtRowIndex = ({
    dtId = '',
    _this = {},
    subMethod = ''
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'getDtRowIndex';
    try {
        let localRowIndex = undefined;
        localRowIndex = $(_this).children('td').children('ul').attr('data-dtr-index');
        if (localRowIndex !== undefined && localRowIndex !== null && localRowIndex !== '') {
            localRowIndex = parseInt(localRowIndex);
        } else {
            localRowIndex = $(`#${dtId}`).DataTable().row(_this).index();
        }
        response.result = localRowIndex;
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}<br/>`;

    }
    return response;
}

export const getProcessButtons = ({
    id = '',
    description = '',
    showDetails = false,
    labelDetails = '',
    //hrefDetails = 'javascript:void(0)', // eslint-disable-line no-script-url
    enabledDetails = false,
    showEdit = false,
    labelEdit = '',
    //hrefEdit = 'javascript:void(0)', // eslint-disable-line no-script-url
    enabledEdit = false,
    showDelete = false,
    labelDelete = '',
    //hrefDelete = 'javascript:void(0)', // eslint-disable-line no-script-url
    enabledDelete = false,
    processButtons = []
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'getProcessButtons';
    try {
        response.result = `<div class='btn-group dropleft'>`;
        response.result += `<button class='btn btn-light border btn-sm dropdown-toggle shadow-sm font-weight-bold' style='border-radius: 5px;' type='button' id='dropdownMenu_${id}' data-toggle='dropdown' aria-expanded='false'> `;
        response.result += `<i class='${settings?.icons?.ellipsisV}'></i> `;
        response.result += `</button> `;
        response.result += `<ul class='dropdown-menu' aria-labelledby='dropdownMenu_${id}'> `;

        //#region primay process
        if (showEdit) {
            response.result += `<li><button `;
            response.result += `class='dropdown-item' `;
            response.result += `description='${description}' `;
            if (!enabledEdit) {
                response.result += `disabled `;
            }
            response.result += `href='javascript:void(0)' `;
            //response.result += `href='${hrefEdit}' `;
            response.result += `id='${id}' `;
            response.result += `method='edit' `;
            response.result += `type='button'><i class='${settings?.icons?.fasFa?.edit}'></i> ${labelEdit}</button></li> `;
        }
        if (showDetails) {
            response.result += `<li><button `;
            response.result += `class='dropdown-item' `;
            response.result += `description='${description}' `;
            if (!enabledDetails) {
                response.result += `disabled `;
            }
            response.result += `href='javascript:void(0)' `;
            //response.result += `href='${hrefDetails}' `;
            response.result += `id='${id}' `;
            response.result += `method='details' `;
            response.result += `type='button'><i class='fas fa-align-justify'></i> ${labelDetails}</button></li> `;
        }
        if (showDelete) {
            response.result += `<li><button `;
            response.result += `class='dropdown-item' `;
            response.result += `description='${description}' `;
            if (!enabledDelete) {
                response.result += `disabled `;
            }
            response.result += `href='javascript:void(0)' `;
            //response.result += `href='${hrefDelete}' `;
            response.result += `id='${id}' `;
            response.result += `method='delete' `;
            response.result += `type='button'><i class='${settings?.icons?.trashFasFa}'></i> ${labelDelete}</button></li> `;
        }
        //#endregion primary process

        //#region add new buttons
        if (!isUndNullEmp({ data: processButtons, subMethod: currentMethod })?.result && processButtons.length > 0) {
            processButtons.forEach((detail) => {
                if (detail.isVisible) {

                    if (detail.showDivider) {
                        response.result += `<li class='dropdown-divider'></li>`;
                    }

                    response.result += `<li><button `;
                    response.result += `class='dropdown-item' `;
                    response.result += `description='${description}' `;
                    if (!detail.isEnabled) {
                        response.result += `disabled `;
                    }
                    response.result += `href='javascript:void(0)' `;
                    response.result += `id='${id}' `;
                    response.result += `method='${detail.methodName}' `;
                    response.result += `type='button'><i class='${detail.icon}'></i> ${detail.label}</button></li> `;
                }
            });
        }
        //#endregion add new buttons

        response.result += `</ul> `;
        response.result += `</div>`;
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.result = '';
        response.msgText = `Method: ${currentMethod}<br/>`;
        // if (!isUndNullEmp({ data: subMethod, subMethod: 'isUndNull' })?.result) {
        //     response.msgText += `Sub method: ${subMethod}<br/>`;
        // }
        response.msgText += `Error: ${ex?.message}<br/>`;
    }
    return response;
}

// export const getProcessButtons = ({
//     id = '',
//     description = '',
//     showDetails = false,
//     labelDetails = '',
//     enabledDetails = false,
//     showEdit = false,
//     labelEdit = '',
//     enabledEdit = false,
//     showDelete = false,
//     labelDelete = '',
//     enabledDelete = false,
//     processButtons = [],
//     languageId = 'en',
// } = {}) => {
//     let response = getResponse({ type: 0 });
//     const currentMethod = 'getProcessButtons';
//     try {
//         //#region Header

//         response.result = `<div class='dropdown d-inline'> `;
//         response.result += `    <button class='btn btn-light dropdown-toggle' title='${settings?.labels?.process[languageId]}' type='button' `;
//         response.result += `        data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'> `;
//         response.result += `        <i class='${settings?.icons?.ellipsisV}'></i> `;
//         response.result += `    </button> `;
//         response.result += `    <div class='dropdown-menu'>  `;

//         //#endregion Header

//         //#region Primay process

//         if (showEdit) {
//             response.result += `        <a id='${id}' `;
//             response.result += `        description='${description}' `;
//             if (!enabledEdit) {
//                 response.result += `        disabeld `;
//             }
//             response.result += `        method='edit' `;
//             response.result += `        class='dropdown-item has-icon' `;
//             response.result += `        href='javascript:void(0)'> `;
//             response.result += `        <i class='${settings?.icons?.fasFa?.edit}'></i> `;
//             response.result += `        ${labelEdit} </a> `;
//         }
//         if (showDetails) {
//             response.result += `        <a id='${id}' `;
//             response.result += `        description='${description}' `;
//             if (!enabledDetails) {
//                 response.result += `        disabeld `;
//             }
//             response.result += `        method='details' `;
//             response.result += `        class='dropdown-item has-icon' `;
//             response.result += `        href='javascript:void(0)'> `;
//             response.result += `        <i class='${settings?.icons?.fasFa?.alignJustify}'></i> `;
//             response.result += `        ${labelDetails} </a> `;
//         }
//         if (showDelete) {
//             response.result += `        <a id='${id}' `;
//             response.result += `        description='${description}' `;
//             if (!enabledDelete) {
//                 response.result += `        disabeld `;
//             }
//             response.result += `        method='delete' `;
//             response.result += `        class='dropdown-item has-icon' `;
//             response.result += `        href='javascript:void(0)'> `;
//             response.result += `        <i class='${settings?.icons?.fasFa?.trash}'></i> `;
//             response.result += `        ${labelDelete} </a> `;
//         }

//         //#endregion Primay process

//         //#region Add new buttons

//         if (!isUndNull({ data: processButtons, subMethod: currentMethod })?.result && processButtons.length > 0) {
//             processButtons.map((detail) => {
//                 if (detail.isVisible) {
//                     if (detail.showDivider) {
//                         response.result += `    <div class='dropdown-divider'></div> `;
//                     }

//                     response.result += `        <a id='${id}' `;
//                     response.result += `        description='${description}' `;
//                     if (!detail.isEnabled) {
//                         response.result += `        disabeld `;
//                     }
//                     response.result += `        method='${detail.methodName}' `;
//                     response.result += `        class='dropdown-item has-icon' `;
//                     response.result += `        href='javascript:void(0)'> `;
//                     response.result += `        <i class='${detail.icon}'></i> `;
//                     response.result += `        ${detail.label} </a> `;
//                 }
//                 return '';
//             });
//         }

//         //#endregion Add new buttons

//         response.result += `    </div>`;
//         response.result += `</div>`;
//     } catch (ex) {
//         response = getResponse({ type: -1 });
//         response.result = '';
//         response.msgText = `Method: ${currentMethod}<br/>`;
//         // if (!isUndNullEmp({ data: subMethod, subMethod: 'isUndNull' })?.result) {
//         //     response.msgText += `Sub method: ${subMethod}<br/>`;
//         // }
//         response.msgText += `Error: ${ex?.message}<br/>`;
//     }
//     return response;
// }

export const notificationsToastGetAsync = async ({
    data = NotificationToast?.getClass({}, false),
    languageId = 'en',
    subMethod = '',
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'notificationsToastGetAsync';
    try {
        //#region variables
        let requestObj = {
            headers: {},
            data: {
                data: data,
                languageId: languageId,
            },
            url: `${settings?.backend?.urls?.api}${settings?.backend?.urls?.apiV1}${settings?.backend?.urls?.notifications}${settings?.backend?.urls?.toasts}/${settings?.backend?.methods?.notifications?.toasts?.getCMNtNr}`,
            subMethod: currentMethod,
        };
        //#endregion variables

        //#region get data
        response = await axios?.post(requestObj);
        if (!response?.isSuccess || response?.isWarning) {
            return response;
        }
        //#endregion get data
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}<br/>`;
    }
    return response;
}

export const notificationsToastPropertiesGet = {
    class: ({
        data = Toast?.getClass({}, false),
        languageId = 'en',
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'notificationsToastPropertiesGet / class';
        try {
            switch (data?.type || 0) {
                case -1:
                    response.result = settings.toast.classes.danger;
                    break;
                case 0:
                    response.result = settings.toast.classes.success;
                    break;
                case 1:
                    response.result = settings.toast.classes.warning;
                    break;
                case 2:
                    response.result = settings.toast.classes.info;
                    break;
                case 3:
                    response.result = settings.toast.classes.info;
                    break;
                case 4:
                    response.result = '';
                    break;
                default:
                    //response.result = '';
                    response.result = settings.toast.classes.maroon;
                    break;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            response.result = 'Error - method';
        }
        return response;
    },
    icon: ({
        data = Toast?.getClass({}, false),
        languageId = 'en',
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'notificationsToastPropertiesGet / icon';
        try {
            switch (data?.type || 0) {
                case -1:
                    response.result = `${settings?.icons?.fasFa?.times} fa-lg`;
                    break;
                case 0:
                    response.result = `${settings?.icons?.fasFa?.checkCircle} fa-lg`;
                    break;
                case 1:
                    response.result = `${settings?.icons?.fasFa?.exclamationTrinagle} fa-lg`;
                    break;
                case 2:
                    response.result = `${settings?.icons?.fasFa?.infoCircle} fa-lg`;
                    break;
                case 3:
                    response.result = `${settings?.icons?.fasFa?.infoCircle} fa-lg`;
                    break;
                case 4:
                    response.result = `${settings?.icons?.fasFa?.infoCircle} fa-lg`;
                    break;
                default:
                    response.result = '';
                    break;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            response.result = 'Error - method';
        }
        return response;
    },
    title: ({
        data = Toast?.getClass({}, false),
        languageId = 'en',
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'notificationsToastPropertiesGet / title';
        try {
            switch (data?.type || 0) {
                case -1:
                    response.result = settings?.labels?.error?.[languageId];
                    break;
                case 0:
                    response.result = settings?.labels?.success?.[languageId];
                    break;
                case 1:
                    response.result = settings?.labels?.warning?.[languageId];
                    break;
                case 2:
                    response.result = settings?.labels?.information?.[languageId];
                    break;
                case 3:
                    response.result = settings?.labels?.question?.[languageId];
                    break;
                case 4:
                    response.result = settings?.labels?.default?.[languageId];
                    break;
                default:
                    response.result = settings?.labels?.success?.[languageId];
                    break;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            response.result = 'Error - method';
        }
        return response;
    },
}

export const notificationsToastShowAsync = async ({
    data = [Toast?.getClass({}, false)],
    languageId = 'en',
    window = {},
    document = {},
    subMethod = '',
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'notificationsToastShowAsync';
    try {
        //TODO; check this to future: https://www.npmjs.com/package/react-toastify
        //implement multi toast in one vertical line.
        //#region show toasts
        if (data?.length > 0) {
            for (let toast of data) {
                let swalIcon = settings?.react?.sweetAlert2?.messages?.types?.success || 'success';
                switch (toast?.type) {
                    case -1: swalIcon = settings?.react?.sweetAlert2?.messages?.types?.error || 'error'; break;
                    case 0: swalIcon = settings?.react?.sweetAlert2?.messages?.types?.success || 'success'; break;
                    case 1: swalIcon = settings?.react?.sweetAlert2?.messages?.types?.warning || 'warning'; break;
                    case 2:
                    case 3:
                    case 4: swalIcon = settings?.react?.sweetAlert2?.messages?.types?.info || 'info'; break;
                    default: swalIcon = settings?.react?.sweetAlert2?.messages?.types?.error || 'error'; break;
                }

                toastSweetalert({
                    position: toast?.position || settings?.react?.sweetAlert2?.position?.topRight || 'top-end',
                    showConfirmButton: false,
                    timer: toast?.delay || settings?.timers?.fiveSeconds || 5000,
                    timerProgressBar: true,
                    icon: swalIcon,
                    iconColor: '',
                    iconHtml: '',
                    background: '',
                    color: '',
                    title: '',
                    html: toast?.message?.replace('<h6>', '')?.replace('</h6>', '') || '',
                });

                // Wait a moment so sequential toasts can stack gracefully in SweetAlert2
                await awaitDelayAsync({ delayTime: 300 });
            }
        }
        //#endregion show toasts
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}<br/>`;
    }
    return response;
}

export const formatBytes = ({
    bytes = 0,
    decimals = settings?.numberPositions?.decimalPlaces
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'formatBytes';
    try {
        if (bytes === 0) {
            response.result = '0 Bytes';
        } else {
            const k = 1024;
            const dm = decimals < 0 ? 0 : decimals;
            const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

            const i = Math.floor(Math.log(bytes) / Math.log(k));

            //return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
            response.result = parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
        }
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.result = '';
        response.msgText = `Method: ${currentMethod}<br/>`;
        response.msgText += `Error: ${ex?.message}<br/>`;
    }
    return response;
}

export const getDocumentMaxFilesMessage = ({
    maxFiles = 0,
    languageId = 'en',
    subMethod = '',
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'getDocumentMaxFilesMessage';
    try {
        response = getResponse({ type: 1 });
        response.msgText = `${settings?.messages?.onlyMaximumNumberOfFilesIsAllowed[languageId]}<br/>`
        response.msgText += `${settings?.messages?.numberAllowed[languageId]}: <b>${maxFiles}</b><br/>`
        response.msgText += `${settings?.messages?.pleaseTryAgain[languageId]}<br/>`
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}<br/>`;
    }
    return response;
}

export const getFileNameByExtension = ({
    fileTypes = [],
    fileMaxSize = 0,
    languageId = 'en',
    subMethod = '',
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'getFileNameByExtension';
    try {
        //#region variables
        //#region response is warning
        let responseIsWarning = getResponse({ type: 1, });
        //#region old code
        // responseIsWarning.msgText = `Method: ${currentMethod}<br/>`;
        // if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
        //     responseIsWarning.msgText += `Sub method: ${subMethod}<br/>`;
        // }
        //#endregion old code
        //#endregion response is warning
        //#endregion variables

        //#region check file type (object)
        if (isUndNullEmp({ data: fileTypes, subMethod: currentMethod })?.result || fileTypes?.length <= 0) {
            responseIsWarning.msgText = `${settings?.messages?.youMustDefineFileTypes[languageId]}<br/>`;
            responseIsWarning.msgText += `${settings?.messages?.pleaseTryAgain[languageId]}`;
            return responseIsWarning;
        }
        //#endregion check file type (object)

        //#region check file types (get names)
        responseIsWarning.msgText = `${settings?.messages?.onlyTheFollowingFilesAreAllowed[languageId]}:<br/>`;
        fileTypes.map((type) => {// eslint-disable-line array-callback-return
            switch (type) {
                //#region images
                case 'image/png':
                    responseIsWarning.msgText += 'PNG, '
                    break;
                case 'image/jpeg':
                    responseIsWarning.msgText += 'JPEG, '
                    break;
                case 'image/jpg':
                    responseIsWarning.msgText += 'JPG, '
                    break;
                case 'image/bmp':
                    responseIsWarning.msgText += 'BMP, '
                    break;
                //#endregion images

                //#region files
                case 'application/msword':
                    if (responseIsWarning.msgText?.indexOf('Word', responseIsWarning.msgText) <= -1) {
                        responseIsWarning.msgText += 'Word, '
                    }
                    break;
                case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                    if (responseIsWarning.msgText?.indexOf('Word', responseIsWarning.msgText) <= -1) {
                        responseIsWarning.msgText += 'Word, '
                    }
                    break;
                case 'application/vnd.ms-excel':
                    if (responseIsWarning.msgText?.indexOf('Excel', responseIsWarning.msgText) <= -1) {
                        responseIsWarning.msgText += 'Excel, '
                    }
                    break;
                case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                    if (responseIsWarning.msgText?.indexOf('Excel', responseIsWarning.msgText) <= -1) {
                        responseIsWarning.msgText += 'Excel, '
                    }
                    break;
                case 'application/vnd.ms-powerpoint':
                    if (responseIsWarning.msgText?.indexOf('Power point', responseIsWarning.msgText) <= -1) {
                        responseIsWarning.msgText += 'Power point, '
                    }
                    break;
                case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                    if (responseIsWarning.msgText?.indexOf('Power point', responseIsWarning.msgText) <= -1) {
                        responseIsWarning.msgText += 'Power point, '
                    }
                    break;
                case 'application/pdf':
                    responseIsWarning.msgText += 'PDF, ';
                    break;
                case 'text/plain':
                    responseIsWarning.msgText += 'TXT, ';
                    break;
                //#endregion files
                default:
                    break;

            }
        });
        //#endregion check file types (get names)

        //#region add leyend max size
        if (fileMaxSize > 0) {
            responseIsWarning.msgText += `<br/>${settings?.messages?.maximunWeightAllowed[languageId]}: <b>${formatBytes({ bytes: fileMaxSize, decimals: 0 })?.result}</b>`;
        }
        //#endregion add leyend max size

        response = responseIsWarning;
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}<br/>`;
    }
    return response;
}

export const checkFile = ({
    type = '',
    size = 0,
    allowedTypes = [],
    maxSize = 0,
    languageId = 'en',
    subMethod = '',
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'checkFile';
    try {
        //#region check file type
        const typeFind = allowedTypes.find((element) => element === type);
        if (isUndNullEmp({ data: typeFind, subMethod: currentMethod })?.result) {
            response = getFileNameByExtension({
                fileTypes: allowedTypes,
                fileMaxSize: maxSize,
                languageId: languageId,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) {
                if (response.isSuccess) {
                    response.msgText += `<br/>${settings?.messages?.pleaseTryAgain.en}`;
                }
                return response;
            }
        }
        //#endregion check file type

        //#region check file size
        if (size > maxSize) {
            response = getFileNameByExtension({
                fileTypes: allowedTypes,
                fileMaxSize: maxSize,
                languageId: languageId,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) {
                if (response.isSuccess) {
                    response.msgText += `<br/>${settings?.messages?.pleaseTryAgain.en}`;
                }
                return response;
            }
        }
        //#endregion check file size
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}<br/>`;
    }
    return response;
}

export const convertFileAsync = {
    //#region tobase64url
    toBase64URL: ({
        file = {},
        subMethod = ''
    } = {}) => {
        return new Promise(resolve => {
            let response = getResponse({ type: 0 });
            const currentMethod = 'convertFileAsync / toBase64URL';
            try {
                let baseURL = "";

                let reader = new FileReader();
                reader.readAsDataURL(file);

                reader.onload = () => {
                    baseURL = reader.result;
                    response.result = baseURL;
                    resolve(response);
                };

                //response.result = fileInfo;
            } catch (ex) {
                response = getResponse({ type: -1 });
                response.msgText = `Method: ${currentMethod}<br/>`;
                if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                    response.msgText += `Sub method: ${subMethod}<br/>`
                }
                response.msgText += `Error: ${ex?.message}<br/>`;
                resolve(response);
            }
            return response
        });
    },
    //#endregion tobase64url
}

export const getUserRoles = ({
    userRole = '',
    subMethod = '',
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'getUserRoles';
    let roles = getRolesType();
    try {
        roles = {
            isAdmin: userRole === settings?.roles?.admin,
            isAnalyst: userRole === settings?.roles?.analyst,
            isAnonymous: userRole === settings?.roles?.anonymous,
            isService: userRole === settings?.roles?.service,
            isUser: userRole === settings?.roles?.user,
            isUserAdmin: userRole === settings?.roles?.userAdmin,
        };
        response.result = roles;
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`
        }
        response.msgText += `Error: ${ex?.message}<br/>`;
        response.result = roles;
        console?.error(response);
    }
    return response;
}

export const LoadingSection = ({
    alt = '',
    className = '',
    showText = true,
    text = '',
    height = 16,
    hidden = false,
    languageId = 'en',
    width = 16,
    subMethod = '',
} = {}) => {
    let response = getResponse({ type: 0 });
    const currentMethod = 'LoadingSection';
    try {
        text = isUndNullEmp({ data: text, subMethod: currentMethod, })?.result ?
            settings?.labels?.loading?.[languageId] :
            text;
        return (
            <div className={className}
                hidden={hidden}>
                <img alt={alt}
                    //#region old code
                    // src={resumeValues?.amination?.src}
                    // height={resumeValues?.amination?.height}
                    // width={resumeValues?.amination?.whidth} /> {resumeValues?.label}
                    //#endregion old code
                    //#region old code
                    // src={settings?.gifs?.normal?.circle}
                    // height={16}
                    // width={16} /> {showText ? `${settings?.labels?.loading?.[languageId]}...` : ''}
                    //#endregion old code
                    src={settings?.gifs?.normal?.circle}
                    height={height}
                    width={width} /> {showText ? `${text}...` : ''}
            </div>
        );
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}<br/>`;
        console?.error(response);
    }
}

export const getServiceHtml = ({
    isChecked = false,
    badgeChecked = '',
    badgeUnchecked = '',
    badgeCheckedIcon = '',
    badgeUncheckedIcon = '',
    labelChecked = '',
    labelUnChecked = '',
    languageId = 'en',
    subMethod = '',
} = {}) => {
    const currentMethod = 'getServiceHtml';
    let response = getResponse({ type: 0 });
    try {
        if (!badgeChecked) badgeChecked = 'badge-success';
        if (!badgeUnchecked) badgeUnchecked = 'badge-secondary';
        if (!badgeCheckedIcon) badgeCheckedIcon = settings?.icons?.fasFa?.checkCircle;
        if (!badgeUncheckedIcon) badgeUncheckedIcon = settings?.icons?.fasFa?.timesCircle;
        if (!labelChecked) labelChecked = settings?.labels?.active?.[languageId];
        if (!labelUnChecked) labelUnChecked = settings?.labels?.inactive?.[languageId];
        response.result = `
                    <div class='d-flex justify-content-center'>
                        <span class='badge badge-pill ${isChecked ? badgeChecked : badgeUnchecked} py-1 px-3 shadow-sm' style='font-size: 0.75rem;'>
                            <i class='${isChecked ? badgeCheckedIcon : badgeUncheckedIcon} mr-1'></i>
                            ${isChecked ? labelChecked : labelUnChecked}
                        </span>
                    </div>`;
    } catch (ex) {
        response = getResponse({ type: -1 });
        response.msgText = `Method: ${currentMethod}<br/>`;
        if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
            response.msgText += `Sub method: ${subMethod}<br/>`;
        }
        response.msgText += `Error: ${ex?.message}<br/>`;
        response.result = 'getServiceHtml: <b>error</b>'
    }
    return response;
}
